import React, { useMemo, useState } from 'react';
import { Mail, MailOpen, MousePointer, ShoppingCart, Send, Eye, Edit, Trash2, Plus, Search, Filter, Download, AlertTriangle, CheckCircle2, Clock, Pause, Play, BarChart3, Users, DollarSign, FileText, Settings, X, ChevronRight, Activity, Zap, RefreshCw, LayoutList, MessageSquare, Globe, ArrowUpRight, ArrowDownRight, SplitSquareHorizontal, Target, Layers, CreditCard, History, TerminalSquare, Bell, Copy, Archive, Ban, Monitor, Smartphone } from 'lucide-react';
import { Card } from '../ui/Card';
import { Button } from '../ui/Button';
import { Badge } from '../ui/Badge';
import { Tabs } from '../ui/Tabs';
import { Pagination } from '../ui/Pagination';
import { Code } from 'lucide-react';
interface EmailCampaignsManagerProps {
  setDetailPanel: (panel: any) => void;
  success: (msg: string) => void;
}
// --- MOCK DATA ---
const mockCampaigns = [{
  id: 'EC-2026-001',
  name: 'Весенний прогноз 2026',
  type: 'promotional',
  advertiser: 'Astriqo',
  segment: 'Все активные пользователи',
  audienceSize: 45000,
  date: '15.03.2026 10:00',
  status: 'sent',
  sent: 45000,
  delivered: 44850,
  opens: 15338,
  openRate: '34.2%',
  clicks: 3363,
  ctr: '7.5%',
  conversions: 340,
  conversionRate: '10.1%',
  revenue: 450000,
  rpm: 10000,
  bounce: 120,
  bounceRate: '0.26%',
  unsubscribe: 45,
  unsubscribeRate: '0.1%',
  spam: 2,
  paymentStatus: 'paid',
  templateId: 'TPL-001',
  subject: 'Ваш весенний астрологический прогноз 🌸',
  previewText: 'Узнайте, что готовят звезды этой весной...',
  abTestId: null,
  automationId: null,
  provider: 'SendGrid',
  senderIdentity: 'news@astriqo.com'
}, {
  id: 'EC-2026-002',
  name: 'Скидка 20% на Соляр',
  type: 'paid_placement',
  advertiser: 'Мария Звёздная',
  segment: 'Пользователи без заказа (30 дней)',
  audienceSize: 12500,
  date: '20.03.2026 12:00',
  status: 'scheduled',
  sent: 0,
  delivered: 0,
  opens: 0,
  openRate: '0%',
  clicks: 0,
  ctr: '0%',
  conversions: 0,
  conversionRate: '0%',
  revenue: 0,
  rpm: 0,
  bounce: 0,
  bounceRate: '0%',
  unsubscribe: 0,
  unsubscribeRate: '0%',
  spam: 0,
  paymentStatus: 'paid',
  templateId: 'TPL-005',
  subject: 'Скидка 20% на ваш Соляр 🎁',
  previewText: 'Только 48 часов! Подготовьтесь к новому году...',
  abTestId: 'AB-001',
  automationId: null,
  provider: 'SendGrid',
  senderIdentity: 'promo@astriqo.com'
}, {
  id: 'EC-2026-003',
  name: 'Дайджест: Апрель',
  type: 'digest',
  advertiser: 'Astriqo',
  segment: 'Подписчики рассылки',
  audienceSize: 85000,
  date: '01.04.2026 09:00',
  status: 'draft',
  sent: 0,
  delivered: 0,
  opens: 0,
  openRate: '0%',
  clicks: 0,
  ctr: '0%',
  conversions: 0,
  conversionRate: '0%',
  revenue: 0,
  rpm: 0,
  bounce: 0,
  bounceRate: '0%',
  unsubscribe: 0,
  unsubscribeRate: '0%',
  spam: 0,
  paymentStatus: 'n/a',
  templateId: 'TPL-002',
  subject: 'Астро-дайджест: Апрель 2026 ♈',
  previewText: 'Главные астрологические события месяца...',
  abTestId: null,
  automationId: null,
  provider: 'SendGrid',
  senderIdentity: 'digest@astriqo.com'
}, {
  id: 'EC-2026-004',
  name: 'Welcome Sequence #1',
  type: 'welcome_sequence',
  advertiser: 'Astriqo',
  segment: 'Новые регистрации',
  audienceSize: 150,
  date: 'Автоматически',
  status: 'sending',
  sent: 12450,
  delivered: 12400,
  opens: 8060,
  openRate: '65.0%',
  clicks: 2418,
  ctr: '19.5%',
  conversions: 450,
  conversionRate: '18.6%',
  revenue: 850000,
  rpm: 68273,
  bounce: 45,
  bounceRate: '0.36%',
  unsubscribe: 12,
  unsubscribeRate: '0.09%',
  spam: 0,
  paymentStatus: 'n/a',
  templateId: 'TPL-003',
  subject: 'Добро пожаловать в Astriqo! ✨',
  senderIdentity: 'welcome@astriqo.com'
}, {
  id: 'EC-2026-005',
  name: 'Брошенная корзина (Натал)',
  type: 'abandoned_cart',
  advertiser: 'Astriqo',
  segment: 'Брошенная корзина > 2ч',
  audienceSize: 45,
  date: 'Автоматически',
  status: 'sending',
  sent: 3200,
  delivered: 3180,
  opens: 1431,
  openRate: '45.0%',
  clicks: 429,
  ctr: '13.5%',
  conversions: 120,
  conversionRate: '27.9%',
  revenue: 348000,
  rpm: 108750,
  bounce: 15,
  bounceRate: '0.47%',
  unsubscribe: 8,
  unsubscribeRate: '0.25%',
  spam: 1,
  paymentStatus: 'n/a',
  templateId: 'TPL-004',
  subject: 'Вы забыли свой расчет натальной карты 🌙',
  previewText: 'Ваша карта ждет вас. Завершите оформление...',
  abTestId: null,
  automationId: 'AUTO-002',
  provider: 'Postmark',
  senderIdentity: 'support@astriqo.com'
}, {
  id: 'EC-2026-006',
  name: 'Реклама курса "Таро для начинающих"',
  type: 'external_ad',
  advertiser: 'Школа Таро',
  segment: 'Интерес: Таро',
  audienceSize: 18000,
  date: '10.03.2026 15:00',
  status: 'failed',
  sent: 5000,
  delivered: 4800,
  opens: 1200,
  openRate: '25.0%',
  clicks: 150,
  ctr: '3.1%',
  conversions: 12,
  conversionRate: '8.0%',
  revenue: 0,
  rpm: 0,
  bounce: 200,
  bounceRate: '4.0%',
  unsubscribe: 85,
  unsubscribeRate: '1.7%',
  spam: 15,
  paymentStatus: 'paid',
  templateId: 'TPL-006',
  subject: 'Освойте Таро за 30 дней 🎴',
  previewText: 'Новый курс от ведущих тарологов...',
  abTestId: null,
  automationId: null,
  provider: 'SendGrid',
  senderIdentity: 'partners@astriqo.com',
  statusReason: 'provider_error'
}, {
  id: 'EC-2026-007',
  name: 'Напоминание об оплате подписки',
  type: 'renewal_reminder',
  advertiser: 'Astriqo',
  segment: 'Подписка истекает через 3 дня',
  audienceSize: 120,
  date: 'Автоматически',
  status: 'paused',
  sent: 8500,
  delivered: 8450,
  opens: 4225,
  openRate: '50.0%',
  clicks: 845,
  ctr: '10.0%',
  conversions: 650,
  conversionRate: '76.9%',
  revenue: 643500,
  rpm: 75705,
  bounce: 40,
  bounceRate: '0.47%',
  unsubscribe: 25,
  unsubscribeRate: '0.29%',
  spam: 0,
  paymentStatus: 'n/a',
  templateId: 'TPL-007',
  subject: 'Ваша подписка скоро истекает ⚡',
  previewText: 'Не потеряйте доступ к премиум функциям...',
  abTestId: null,
  automationId: 'AUTO-003',
  provider: 'Postmark',
  senderIdentity: 'billing@astriqo.com',
  statusReason: 'manually_paused'
}];
const mockTemplates = [{
  id: 'TPL-001',
  name: 'Стандартный промо',
  type: 'promo',
  subject: 'Специальное предложение для вас',
  previewText: 'Узнайте подробности внутри...',
  status: 'active',
  version: '1.2',
  updatedAt: '10.03.2026'
}, {
  id: 'TPL-002',
  name: 'Ежемесячный дайджест',
  type: 'newsletter',
  subject: 'Астро-дайджест',
  previewText: 'Главные события месяца',
  status: 'active',
  version: '3.0',
  updatedAt: '01.03.2026'
}, {
  id: 'TPL-003',
  name: 'Welcome Email',
  type: 'transactional',
  subject: 'Добро пожаловать!',
  previewText: 'С чего начать...',
  status: 'active',
  version: '2.1',
  updatedAt: '15.01.2026'
}];
const mockSegments = [{
  id: 'SEG-001',
  name: 'Все активные пользователи',
  size: 45000,
  type: 'dynamic',
  rules: 'last_login < 30 days',
  updatedAt: 'Сегодня, 10:00'
}, {
  id: 'SEG-002',
  name: 'VIP клиенты',
  size: 1250,
  type: 'dynamic',
  rules: 'ltv > 50000 RUB',
  updatedAt: 'Сегодня, 10:00'
}, {
  id: 'SEG-003',
  name: 'Интерес: Таро',
  size: 18000,
  type: 'static',
  rules: 'purchased_category = tarot OR viewed_category = tarot',
  updatedAt: 'Вчера, 15:30'
}];
const mockAutomations = [{
  id: 'AUTO-001',
  name: 'Welcome Sequence',
  trigger: 'User Registration',
  steps: 3,
  activeSubscribers: 450,
  completed: 12450,
  status: 'active'
}, {
  id: 'AUTO-002',
  name: 'Abandoned Cart',
  trigger: 'Cart Abandoned > 2h',
  steps: 2,
  activeSubscribers: 85,
  completed: 3200,
  status: 'active'
}, {
  id: 'AUTO-003',
  name: 'Subscription Renewal',
  trigger: 'Subscription expires in 3 days',
  steps: 1,
  activeSubscribers: 120,
  completed: 8500,
  status: 'paused'
}];
const mockAbTests = [{
  id: 'AB-001',
  name: 'Промо Соляр: Тема письма',
  campaignId: 'EC-2026-002',
  type: 'subject',
  variantA: 'Скидка 20% на ваш Соляр 🎁',
  variantB: 'Подготовьтесь к новому году: -20% на Соляр ✨',
  split: '50/50',
  status: 'scheduled',
  winner: null
}, {
  id: 'AB-002',
  name: 'Welcome: Кнопка CTA',
  campaignId: 'EC-2026-004',
  type: 'cta',
  variantA: 'Рассчитать карту',
  variantB: 'Узнать свою судьбу',
  split: '50/50',
  status: 'completed',
  winner: 'Variant B (+15% CTR)'
}];
// --- CONFIGS ---
const campaignTypeConfig: Record<string, {
  label: string;
  color: string;
}> = {
  promotional: {
    label: 'Промо',
    color: 'bg-amber-100 text-amber-700 border-amber-200'
  },
  paid_placement: {
    label: 'Платное',
    color: 'bg-purple-100 text-purple-700 border-purple-200'
  },
  digest: {
    label: 'Дайджест',
    color: 'bg-blue-100 text-blue-700 border-blue-200'
  },
  system: {
    label: 'Системное',
    color: 'bg-slate-100 text-slate-700 border-slate-200'
  },
  welcome_sequence: {
    label: 'Welcome',
    color: 'bg-emerald-100 text-emerald-700 border-emerald-200'
  },
  abandoned_cart: {
    label: 'Брошенная корзина',
    color: 'bg-orange-100 text-orange-700 border-orange-200'
  },
  renewal_reminder: {
    label: 'Продление',
    color: 'bg-indigo-100 text-indigo-700 border-indigo-200'
  },
  external_ad: {
    label: 'Внешняя реклама',
    color: 'bg-rose-100 text-rose-700 border-rose-200'
  }
};
const campaignStatusConfig: Record<string, {
  label: string;
  variant: 'success' | 'warning' | 'error' | 'neutral' | 'pro';
}> = {
  draft: {
    label: 'Черновик',
    variant: 'neutral'
  },
  scheduled: {
    label: 'Запланировано',
    variant: 'warning'
  },
  sending: {
    label: 'Отправляется',
    variant: 'pro'
  },
  sent: {
    label: 'Отправлено',
    variant: 'success'
  },
  paused: {
    label: 'На паузе',
    variant: 'neutral'
  },
  failed: {
    label: 'Ошибка',
    variant: 'error'
  },
  archived: {
    label: 'В архиве',
    variant: 'neutral'
  }
};
const formatCurrency = (amount: number) => {
  return new Intl.NumberFormat('ru-RU', {
    style: 'currency',
    currency: 'RUB',
    maximumFractionDigits: 0
  }).format(amount);
};
export function EmailCampaignsManager({
  setDetailPanel,
  success
}: EmailCampaignsManagerProps) {
  const [campaigns, setCampaigns] = useState(mockCampaigns);
  const [activeTab, setActiveTab] = useState('campaigns');
  const [searchQuery, setSearchQuery] = useState('');
  const [showFilters, setShowFilters] = useState(false);
  const [filters, setFilters] = useState({
    status: 'all',
    type: 'all'
  });
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;
  const [showCreateModal, setShowCreateModal] = useState(false);
  const [editingCampaign, setEditingCampaign] = useState<any | null>(null);
  const [createForm, setCreateForm] = useState({
    name: '',
    type: 'promotional',
    subject: '',
    previewText: '',
    templateId: 'TPL-001',
    segment: 'Все активные пользователи (~45k)',
    sendDate: ''
  });
  const [selectedCampaigns, setSelectedCampaigns] = useState<Set<string>>(new Set());
  // Detail Modal State
  const [activeCampaignDetail, setActiveCampaignDetail] = useState<any | null>(null);
  const [detailTab, setDetailTab] = useState('overview');
  // Template Detail Modal
  const [activeTemplateDetail, setActiveTemplateDetail] = useState<any | null>(null);
  const [templateEditMode, setTemplateEditMode] = useState(false);
  const [templateForm, setTemplateForm] = useState({
    name: '',
    type: 'promo',
    subject: '',
    previewText: ''
  });
  // Segment Detail Modal
  const [activeSegmentDetail, setActiveSegmentDetail] = useState<any | null>(null);
  const [segmentEditMode, setSegmentEditMode] = useState(false);
  const [segmentForm, setSegmentForm] = useState({
    name: '',
    type: 'dynamic',
    rules: ''
  });
  // Automation Detail Modal
  const [activeAutomationDetail, setActiveAutomationDetail] = useState<any | null>(null);
  const [automationEditMode, setAutomationEditMode] = useState(false);
  // A/B Test Detail Modal
  const [activeAbTestDetail, setActiveAbTestDetail] = useState<any | null>(null);
  // --- FILTERING ---
  const filteredCampaigns = useMemo(() => {
    return campaigns.filter(c => {
      const matchesSearch = c.name.toLowerCase().includes(searchQuery.toLowerCase()) || c.id.toLowerCase().includes(searchQuery.toLowerCase()) || c.advertiser.toLowerCase().includes(searchQuery.toLowerCase());
      if (!matchesSearch) return false;
      if (filters.status !== 'all' && c.status !== filters.status) return false;
      if (filters.type !== 'all' && c.type !== filters.type) return false;
      return true;
    });
  }, [campaigns, searchQuery, filters]);
  const totalPages = Math.ceil(filteredCampaigns.length / itemsPerPage);
  const currentCampaigns = filteredCampaigns.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage);
  const toggleSelectAll = () => {
    if (selectedCampaigns.size === currentCampaigns.length) {
      setSelectedCampaigns(new Set());
    } else {
      setSelectedCampaigns(new Set(currentCampaigns.map(c => c.id)));
    }
  };
  const toggleSelect = (id: string) => {
    const newSet = new Set(selectedCampaigns);
    if (newSet.has(id)) newSet.delete(id);else newSet.add(id);
    setSelectedCampaigns(newSet);
  };
  // --- ACTIONS ---
  const handleAction = (action: string, id?: string) => {
    const targetId = id || (selectedCampaigns.size === 1 ? Array.from(selectedCampaigns)[0] : null);
    const count = id ? 1 : selectedCampaigns.size;
    switch (action) {
      case 'pause':
        success(`Приостановлено кампаний: ${count}`);
        break;
      case 'resume':
        success(`Возобновлено кампаний: ${count}`);
        break;
      case 'archive':
        success(`Архивировано кампаний: ${count}`);
        break;
      case 'duplicate':
        success(`Кампания скопирована`);
        break;
      case 'export':
        success(`Экспорт данных начат`);
        break;
    }
    if (!id) setSelectedCampaigns(new Set());
  };
  const openDetail = (campaign: any) => {
    setActiveCampaignDetail(campaign);
    setDetailTab('overview');
  };
  // --- RENDERERS ---
  const renderKpiCard = (label: string, value: string | number, icon: React.ReactNode, bgClass: string, textClass: string, onClickFilter?: Partial<typeof filters>) => <Card padding="sm" hoverable className="rounded-xl shadow-none border-slate-200 p-4 flex flex-col justify-between h-24 cursor-pointer group transition-all hover:border-indigo-300 hover:shadow-md" onClick={() => {
    if (onClickFilter) {
      setFilters({
        ...filters,
        ...onClickFilter
      });
      setCurrentPage(1);
      setActiveTab('campaigns');
    }
  }} data-id="element-10185">
      <div className="flex justify-between items-start" data-id="element-10186">
        <div className={`w-8 h-8 rounded-lg ${bgClass} flex items-center justify-center group-hover:scale-110 transition-transform`} data-id="element-10187">
          {icon}
        </div>
      </div>
      <div data-id="element-10188">
        <div className="text-xs text-slate-500 font-medium mb-0.5" data-id="element-10189">{label}</div>
        <div className={`text-xl font-bold ${textClass}`} data-id="element-10190">{value}</div>
      </div>
    </Card>;
  const renderTopMetrics = () => <div className="grid grid-cols-2 md:grid-cols-5 gap-3 mb-6" data-id="element-10191">
      {renderKpiCard('Всего кампаний', mockCampaigns.length, <Mail className="w-4 h-4 text-indigo-600" data-id="element-10192" />, 'bg-indigo-50', 'text-slate-900', {
      status: 'all'
    })}
      {renderKpiCard('Ср. Open Rate', '38.4%', <MailOpen className="w-4 h-4 text-blue-600" data-id="element-10193" />, 'bg-blue-50', 'text-blue-700')}
      {renderKpiCard('Ср. CTR', '8.2%', <MousePointer className="w-4 h-4 text-purple-600" data-id="element-10194" />, 'bg-purple-50', 'text-purple-700')}
      {renderKpiCard('Конверсии', '1,462', <ShoppingCart className="w-4 h-4 text-amber-600" data-id="element-10195" />, 'bg-amber-50', 'text-amber-700')}
      {renderKpiCard('Доход', '2.2M ₽', <DollarSign className="w-4 h-4 text-emerald-600" data-id="element-10196" />, 'bg-emerald-50', 'text-emerald-700')}

      {renderKpiCard('Отправлено', '71K', <Send className="w-4 h-4 text-slate-600" data-id="element-10197" />, 'bg-slate-100', 'text-slate-900')}
      {renderKpiCard('Доставлено', '99.2%', <CheckCircle2 className="w-4 h-4 text-emerald-600" data-id="element-10198" />, 'bg-emerald-50', 'text-emerald-700')}
      {renderKpiCard('Bounce Rate', '0.8%', <ArrowUpRight className="w-4 h-4 text-orange-600" data-id="element-10199" />, 'bg-orange-50', 'text-orange-700')}
      {renderKpiCard('Unsubscribe', '0.2%', <ArrowDownRight className="w-4 h-4 text-rose-600" data-id="element-10200" />, 'bg-rose-50', 'text-rose-700')}
      {renderKpiCard('В процессе', '2', <Activity className="w-4 h-4 text-indigo-600" data-id="element-10201" />, 'bg-indigo-50', 'text-indigo-700', {
      status: 'sending'
    })}
    </div>;
  const renderCampaignsTable = () => <div className="space-y-4" data-id="element-10202">
      {/* Filter Bar */}
      <Card padding="sm" className="rounded-xl shadow-none border-slate-200" data-id="element-10203">
        <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4" data-id="element-10204">
          <div className="flex items-center gap-3 w-full sm:w-auto flex-1" data-id="element-10205">
            <div className="relative flex-1 max-w-md" data-id="element-10206">
              <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-slate-400" data-id="element-10207" />
              <input type="text" placeholder="Поиск по ID, названию, рекламодателю..." className="w-full pl-9 pr-4 py-2 text-sm border border-slate-200 rounded-lg focus:outline-none focus:border-indigo-500" value={searchQuery} onChange={e => setSearchQuery(e.target.value)} data-id="element-10208" />
            </div>
            <Button variant={showFilters ? 'primary' : 'outline'} size="sm" icon={<Filter className="w-4 h-4" data-id="element-10210" />} onClick={() => setShowFilters(!showFilters)} data-id="element-10209">
              Фильтры
            </Button>
          </div>
          <div className="flex items-center gap-3 w-full sm:w-auto" data-id="element-10211">
            <Button variant="outline" size="sm" icon={<Download className="w-4 h-4" data-id="element-10213" />} onClick={() => handleAction('export')} data-id="element-10212">
              Экспорт
            </Button>
            <Button variant="primary" size="sm" icon={<Plus className="w-4 h-4" data-id="element-10215" />} onClick={() => {
            setEditingCampaign(null);
            setCreateForm({
              name: '',
              type: 'promotional',
              subject: '',
              previewText: '',
              templateId: 'TPL-001',
              segment: 'Все активные пользователи (~45k)',
              sendDate: ''
            });
            setShowCreateModal(true);
          }} data-id="element-10214">
              Создать кампанию
            </Button>
          </div>
        </div>

        {showFilters && <div className="mt-4 pt-4 border-t border-slate-100 grid grid-cols-1 sm:grid-cols-4 gap-4 animate-in fade-in slide-in-from-top-2" data-id="element-10216">
            <div data-id="element-10217">
              <label className="block text-[10px] font-bold text-slate-500 uppercase tracking-wider mb-1" data-id="element-10218">
                Статус
              </label>
              <select className="w-full rounded-lg border border-slate-200 bg-white text-sm py-2 px-3" value={filters.status} onChange={e => setFilters({
            ...filters,
            status: e.target.value
          })} data-id="element-10219">
                <option value="all" data-id="element-10220">Все статусы</option>
                <option value="draft" data-id="element-10221">Черновик</option>
                <option value="scheduled" data-id="element-10222">Запланировано</option>
                <option value="sending" data-id="element-10223">Отправляется</option>
                <option value="sent" data-id="element-10224">Отправлено</option>
                <option value="paused" data-id="element-10225">На паузе</option>
                <option value="failed" data-id="element-10226">Ошибка</option>
              </select>
            </div>
            <div data-id="element-10227">
              <label className="block text-[10px] font-bold text-slate-500 uppercase tracking-wider mb-1" data-id="element-10228">
                Тип
              </label>
              <select className="w-full rounded-lg border border-slate-200 bg-white text-sm py-2 px-3" value={filters.type} onChange={e => setFilters({
            ...filters,
            type: e.target.value
          })} data-id="element-10229">
                <option value="all" data-id="element-10230">Все типы</option>
                <option value="promotional" data-id="element-10231">Промо</option>
                <option value="paid_placement" data-id="element-10232">Платное</option>
                <option value="digest" data-id="element-10233">Дайджест</option>
                <option value="welcome_sequence" data-id="element-10234">Welcome</option>
                <option value="abandoned_cart" data-id="element-10235">Брошенная корзина</option>
              </select>
            </div>
          </div>}
      </Card>

      {/* Mass Actions */}
      {selectedCampaigns.size > 0 && <div className="bg-indigo-50 border border-indigo-100 rounded-xl p-3 flex items-center justify-between animate-in fade-in" data-id="element-10236">
          <div className="flex items-center gap-3" data-id="element-10237">
            <Badge variant="pro" data-id="element-10238">{selectedCampaigns.size} выбрано</Badge>
            <span className="text-sm text-indigo-800 font-medium" data-id="element-10239">
              Действия:
            </span>
          </div>
          <div className="flex items-center gap-2" data-id="element-10240">
            <Button variant="outline" size="sm" className="bg-white" icon={<Pause className="w-4 h-4" data-id="element-10242" />} onClick={() => handleAction('pause')} data-id="element-10241">
              Пауза
            </Button>
            <Button variant="outline" size="sm" className="bg-white" icon={<Play className="w-4 h-4" data-id="element-10244" />} onClick={() => handleAction('resume')} data-id="element-10243">
              Возобновить
            </Button>
            <Button variant="outline" size="sm" className="bg-white text-rose-600 hover:text-rose-700 hover:bg-rose-50" icon={<Archive className="w-4 h-4" data-id="element-10246" />} onClick={() => handleAction('archive')} data-id="element-10245">
              В архив
            </Button>
          </div>
        </div>}

      {/* Table */}
      <Card padding="none" className="rounded-xl shadow-sm border-slate-200 overflow-hidden" data-id="element-10247">
        <div className="overflow-x-auto" data-id="element-10248">
          <table className="w-full text-left whitespace-nowrap" data-id="element-10249">
            <thead className="bg-slate-50 text-slate-500 border-b border-slate-200 text-[11px] uppercase tracking-wider" data-id="element-10250">
              <tr data-id="element-10251">
                <th className="px-4 py-3 w-10 text-center" data-id="element-10252">
                  <input type="checkbox" className="rounded text-indigo-600 focus:ring-indigo-500" checked={selectedCampaigns.size === currentCampaigns.length && currentCampaigns.length > 0} onChange={toggleSelectAll} data-id="element-10253" />
                </th>
                <th className="px-4 py-3 font-medium" data-id="element-10254">Кампания</th>
                <th className="px-4 py-3 font-medium" data-id="element-10255">Статус</th>
                <th className="px-4 py-3 font-medium" data-id="element-10256">Аудитория</th>
                <th className="px-4 py-3 font-medium" data-id="element-10257">Отправлено</th>
                <th className="px-4 py-3 font-medium" data-id="element-10258">Open Rate</th>
                <th className="px-4 py-3 font-medium" data-id="element-10259">CTR</th>
                <th className="px-4 py-3 font-medium" data-id="element-10260">Конверсии</th>
                <th className="px-4 py-3 font-medium" data-id="element-10261">Доход</th>
                <th className="px-4 py-3 text-right font-medium" data-id="element-10262">Действия</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-100" data-id="element-10263">
              {currentCampaigns.map(c => {
              const typeInfo = campaignTypeConfig[c.type];
              const statusInfo = campaignStatusConfig[c.status];
              return <tr key={c.id} className="hover:bg-slate-50 transition-colors group" data-id="element-10264">
                    <td className="px-4 py-3 text-center" data-id="element-10265">
                      <input type="checkbox" className="rounded text-indigo-600 focus:ring-indigo-500" checked={selectedCampaigns.has(c.id)} onChange={() => toggleSelect(c.id)} data-id="element-10266" />
                    </td>
                    <td className="px-4 py-3" data-id="element-10267">
                      <div className="flex flex-col gap-1" data-id="element-10268">
                        <div className="text-sm font-bold text-slate-900 cursor-pointer hover:text-indigo-600 transition-colors" onClick={() => openDetail(c)} data-id="element-10269">
                          {c.name}
                        </div>
                        <div className="flex items-center gap-2" data-id="element-10270">
                          <span className="text-[10px] text-slate-500 font-mono" data-id="element-10271">
                            {c.id}
                          </span>
                          <span className={`text-[10px] px-1.5 py-0.5 rounded border ${typeInfo?.color || 'bg-slate-100 text-slate-600'}`} data-id="element-10272">
                            {typeInfo?.label || c.type}
                          </span>
                          {c.abTestId && <span className="text-[10px] px-1.5 py-0.5 rounded border bg-amber-50 text-amber-600 border-amber-200 flex items-center gap-1" data-id="element-10273">
                              <SplitSquareHorizontal className="w-3 h-3" data-id="element-10274" /> A/B
                            </span>}
                        </div>
                      </div>
                    </td>
                    <td className="px-4 py-3" data-id="element-10275">
                      <Badge variant={statusInfo?.variant || 'neutral'} size="sm" className="cursor-pointer" onClick={() => openDetail(c)} data-id="element-10276">
                        {statusInfo?.label || c.status}
                      </Badge>
                      <div className="text-[10px] text-slate-400 mt-1" data-id="element-10277">
                        {c.date}
                      </div>
                    </td>
                    <td className="px-4 py-3" data-id="element-10278">
                      <div className="text-sm text-slate-700 font-medium cursor-pointer hover:text-indigo-600" onClick={() => setActiveTab('audiences')} data-id="element-10279">
                        {c.segment}
                      </div>
                      <div className="text-[10px] text-slate-500 flex items-center gap-1 mt-0.5" data-id="element-10280">
                        <Users className="w-3 h-3" data-id="element-10281" />{' '}
                        {c.audienceSize.toLocaleString('ru-RU')}
                      </div>
                    </td>
                    <td className="px-4 py-3" data-id="element-10282">
                      <div className="text-sm font-medium text-slate-900" data-id="element-10283">
                        {c.sent.toLocaleString('ru-RU')}
                      </div>
                      <div className="text-[10px] text-slate-500" data-id="element-10284">
                        Дост: {c.delivered.toLocaleString('ru-RU')}
                      </div>
                    </td>
                    <td className="px-4 py-3" data-id="element-10285">
                      <div className="text-sm font-bold text-blue-600 cursor-pointer hover:underline" onClick={() => openDetail(c)} data-id="element-10286">
                        {c.openRate}
                      </div>
                      <div className="text-[10px] text-slate-500" data-id="element-10287">
                        {c.opens.toLocaleString('ru-RU')} откр.
                      </div>
                    </td>
                    <td className="px-4 py-3" data-id="element-10288">
                      <div className="text-sm font-bold text-purple-600 cursor-pointer hover:underline" onClick={() => openDetail(c)} data-id="element-10289">
                        {c.ctr}
                      </div>
                      <div className="text-[10px] text-slate-500" data-id="element-10290">
                        {c.clicks.toLocaleString('ru-RU')} клик.
                      </div>
                    </td>
                    <td className="px-4 py-3" data-id="element-10291">
                      <div className="text-sm font-bold text-amber-600 cursor-pointer hover:underline" onClick={() => openDetail(c)} data-id="element-10292">
                        {c.conversions}
                      </div>
                      <div className="text-[10px] text-slate-500" data-id="element-10293">
                        CR: {c.conversionRate}
                      </div>
                    </td>
                    <td className="px-4 py-3" data-id="element-10294">
                      <div className="text-sm font-bold text-emerald-600 cursor-pointer hover:underline" onClick={() => openDetail(c)} data-id="element-10295">
                        {formatCurrency(c.revenue)}
                      </div>
                      <div className="text-[10px] text-slate-500" data-id="element-10296">
                        RPM: {formatCurrency(c.rpm)}
                      </div>
                    </td>
                    <td className="px-4 py-3 text-right" data-id="element-10297">
                      <div className="flex items-center justify-end gap-1 opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-10298">
                        <Button variant="ghost" size="sm" className="w-8 h-8 p-0 text-slate-400 hover:text-indigo-600" icon={<Eye className="w-4 h-4" data-id="element-10300" />} onClick={() => openDetail(c)} title="Просмотр" data-id="element-10299" />
                        <Button variant="ghost" size="sm" className="w-8 h-8 p-0 text-slate-400 hover:text-blue-600" icon={<Edit className="w-4 h-4" data-id="element-10302" />} onClick={() => {
                      setEditingCampaign(c);
                      setCreateForm({
                        name: c.name,
                        type: c.type,
                        subject: c.subject,
                        previewText: c.previewText,
                        templateId: c.templateId,
                        segment: c.segment,
                        sendDate: c.date !== 'Автоматически' ? c.date : ''
                      });
                      setShowCreateModal(true);
                    }} title="Редактировать" data-id="element-10301" />
                        <Button variant="ghost" size="sm" className="w-8 h-8 p-0 text-slate-400 hover:text-amber-600" icon={<Copy className="w-4 h-4" data-id="element-10304" />} onClick={() => handleAction('duplicate', c.id)} title="Дублировать" data-id="element-10303" />
                        {c.status === 'sending' || c.status === 'scheduled' ? <Button variant="ghost" size="sm" className="w-8 h-8 p-0 text-slate-400 hover:text-orange-600" icon={<Pause className="w-4 h-4" data-id="element-10306" />} onClick={() => handleAction('pause', c.id)} title="Пауза" data-id="element-10305" /> : c.status === 'paused' ? <Button variant="ghost" size="sm" className="w-8 h-8 p-0 text-slate-400 hover:text-emerald-600" icon={<Play className="w-4 h-4" data-id="element-10308" />} onClick={() => handleAction('resume', c.id)} title="Возобновить" data-id="element-10307" /> : null}
                      </div>
                    </td>
                  </tr>;
            })}
            </tbody>
          </table>
        </div>
        {totalPages > 1 && <div className="p-4 border-t border-slate-100 bg-slate-50 flex justify-center" data-id="element-10309">
            <Pagination currentPage={currentPage} totalPages={totalPages} onPageChange={setCurrentPage} data-id="element-10310" />
          </div>}
      </Card>
    </div>;
  const renderTemplates = () => <div className="space-y-4" data-id="element-10311">
      <div className="flex justify-between items-center" data-id="element-10312">
        <div data-id="element-10313">
          <h3 className="text-lg font-bold text-slate-900" data-id="element-10314">Шаблоны писем</h3>
          <p className="text-sm text-slate-500" data-id="element-10315">
            Управление HTML-шаблонами для рассылок
          </p>
        </div>
        <Button variant="primary" icon={<Plus className="w-4 h-4" data-id="element-10317" />} onClick={() => {
        setTemplateEditMode(true);
        setTemplateForm({
          name: '',
          type: 'promo',
          subject: '',
          previewText: ''
        });
        setActiveTemplateDetail({
          id: 'NEW',
          name: 'Новый шаблон',
          status: 'draft'
        });
      }} data-id="element-10316">
          Создать шаблон
        </Button>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4" data-id="element-10318">
        {mockTemplates.map(t => <Card key={t.id} padding="md" hoverable className="rounded-xl shadow-none border-slate-200 cursor-pointer" onClick={() => {
        setTemplateEditMode(false);
        setActiveTemplateDetail(t);
      }} data-id="element-10319">
            <div className="flex justify-between items-start mb-4" data-id="element-10320">
              <div className="w-10 h-10 rounded-lg bg-indigo-50 flex items-center justify-center text-indigo-600" data-id="element-10321">
                <LayoutList className="w-5 h-5" data-id="element-10322" />
              </div>
              <Badge variant={t.status === 'active' ? 'success' : 'neutral'} data-id="element-10323">
                {t.status}
              </Badge>
            </div>
            <h4 className="font-bold text-slate-900 mb-1" data-id="element-10324">{t.name}</h4>
            <p className="text-xs text-slate-500 mb-4 line-clamp-2" data-id="element-10325">
              {t.subject}
            </p>
            <div className="flex items-center justify-between text-[10px] text-slate-400 pt-3 border-t border-slate-100" data-id="element-10326">
              <span className="font-mono" data-id="element-10327">{t.id}</span>
              <span data-id="element-10328">
                v{t.version} • {t.updatedAt}
              </span>
            </div>
          </Card>)}
      </div>
    </div>;
  const renderAudiences = () => <div className="space-y-4" data-id="element-10329">
      <div className="flex justify-between items-center" data-id="element-10330">
        <div data-id="element-10331">
          <h3 className="text-lg font-bold text-slate-900" data-id="element-10332">
            Сегменты аудитории
          </h3>
          <p className="text-sm text-slate-500" data-id="element-10333">
            Динамические и статические списки получателей
          </p>
        </div>
        <Button variant="primary" icon={<Plus className="w-4 h-4" data-id="element-10335" />} onClick={() => {
        setSegmentEditMode(true);
        setSegmentForm({
          name: '',
          type: 'dynamic',
          rules: ''
        });
        setActiveSegmentDetail({
          id: 'NEW',
          name: 'Новый сегмент',
          size: 0,
          type: 'dynamic'
        });
      }} data-id="element-10334">
          Создать сегмент
        </Button>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4" data-id="element-10336">
        {mockSegments.map(s => <Card key={s.id} padding="md" hoverable className="rounded-xl shadow-none border-slate-200 cursor-pointer" onClick={() => {
        setSegmentEditMode(false);
        setActiveSegmentDetail(s);
      }} data-id="element-10337">
            <div className="flex justify-between items-start mb-4" data-id="element-10338">
              <div className="w-12 h-12 rounded-xl bg-emerald-50 flex items-center justify-center text-emerald-600 shrink-0" data-id="element-10339">
                <Users className="w-6 h-6" data-id="element-10340" />
              </div>
              <Badge variant={s.type === 'dynamic' ? 'pro' : 'neutral'} data-id="element-10341">
                {s.type}
              </Badge>
            </div>
            <h4 className="font-bold text-slate-900 mb-1" data-id="element-10342">{s.name}</h4>
            <div className="text-2xl font-bold text-slate-700 mb-4" data-id="element-10343">
              {s.size.toLocaleString('ru-RU')}{' '}
              <span className="text-xs font-normal text-slate-500" data-id="element-10344">
                пользователей
              </span>
            </div>
            <div className="flex items-center justify-between text-[10px] text-slate-400 pt-3 border-t border-slate-100" data-id="element-10345">
              <span className="truncate max-w-[150px]" title={s.rules} data-id="element-10346">
                {s.rules}
              </span>
              <span data-id="element-10347">{s.updatedAt}</span>
            </div>
          </Card>)}
      </div>
    </div>;
  const renderAutomations = () => <div className="space-y-4" data-id="element-10348">
      <div className="flex justify-between items-center" data-id="element-10349">
        <div data-id="element-10350">
          <h3 className="text-lg font-bold text-slate-900" data-id="element-10351">Автоматизации</h3>
          <p className="text-sm text-slate-500" data-id="element-10352">
            Триггерные цепочки писем (Flows)
          </p>
        </div>
        <Button variant="primary" icon={<Plus className="w-4 h-4" data-id="element-10354" />} onClick={() => {
        setAutomationEditMode(true);
        setActiveAutomationDetail({
          id: 'NEW',
          name: 'Новая автоматизация',
          status: 'draft',
          steps: 0,
          activeSubscribers: 0,
          completed: 0
        });
      }} data-id="element-10353">
          Создать Flow
        </Button>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4" data-id="element-10355">
        {mockAutomations.map(a => <Card key={a.id} padding="md" hoverable className="rounded-xl shadow-none border-slate-200 cursor-pointer" onClick={() => {
        setAutomationEditMode(false);
        setActiveAutomationDetail(a);
      }} data-id="element-10356">
            <div className="flex justify-between items-start mb-4" data-id="element-10357">
              <div className="w-12 h-12 rounded-xl bg-amber-50 flex items-center justify-center text-amber-600 shrink-0" data-id="element-10358">
                <Zap className="w-5 h-5" data-id="element-10359" />
              </div>
              <Badge variant={a.status === 'active' ? 'success' : 'neutral'} data-id="element-10360">
                {a.status}
              </Badge>
            </div>
            <h4 className="font-bold text-slate-900 mb-1" data-id="element-10361">{a.name}</h4>
            <p className="text-xs text-slate-500 mb-4 flex items-center gap-1" data-id="element-10362">
              <Target className="w-3 h-3" data-id="element-10363" /> {a.trigger}
            </p>
            <div className="grid grid-cols-3 gap-2 mb-4" data-id="element-10364">
              <div className="bg-slate-50 p-2 rounded text-center" data-id="element-10365">
                <div className="text-xs font-bold text-slate-900" data-id="element-10366">
                  {a.steps}
                </div>
                <div className="text-[9px] text-slate-500" data-id="element-10367">Шагов</div>
              </div>
              <div className="bg-slate-50 p-2 rounded text-center" data-id="element-10368">
                <div className="text-xs font-bold text-slate-900" data-id="element-10369">
                  {a.activeSubscribers}
                </div>
                <div className="text-[9px] text-slate-500" data-id="element-10370">Активны</div>
              </div>
              <div className="bg-slate-50 p-2 rounded text-center" data-id="element-10371">
                <div className="text-xs font-bold text-slate-900" data-id="element-10372">
                  {a.completed >= 1000 ? `${(a.completed / 1000).toFixed(1)}k` : a.completed}
                </div>
                <div className="text-[9px] text-slate-500" data-id="element-10373">Завершили</div>
              </div>
            </div>
            <div className="flex items-center justify-between text-[10px] text-slate-400 pt-3 border-t border-slate-100" data-id="element-10374">
              <span className="font-mono" data-id="element-10375">{a.id}</span>
              <span className="text-indigo-600 font-medium hover:underline" data-id="element-10376">
                Редактировать Flow
              </span>
            </div>
          </Card>)}
      </div>
    </div>;
  const renderAbTests = () => <div className="space-y-4" data-id="element-10377">
      <div className="flex justify-between items-center" data-id="element-10378">
        <div data-id="element-10379">
          <h3 className="text-lg font-bold text-slate-900" data-id="element-10380">A/B Тесты</h3>
          <p className="text-sm text-slate-500" data-id="element-10381">Сплит-тестирование кампаний</p>
        </div>
        <Button variant="primary" icon={<Plus className="w-4 h-4" data-id="element-10383" />} onClick={() => {
        setActiveAbTestDetail({
          id: 'NEW',
          name: 'Новый A/B тест',
          status: 'draft',
          split: '50/50'
        });
      }} data-id="element-10382">
          Новый тест
        </Button>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-10384">
        {mockAbTests.map(t => <Card key={t.id} padding="md" hoverable className="rounded-xl shadow-none border-slate-200 cursor-pointer" onClick={() => setActiveAbTestDetail(t)} data-id="element-10385">
            <div className="flex justify-between items-start mb-4" data-id="element-10386">
              <div className="flex items-center gap-3" data-id="element-10387">
                <div className="w-10 h-10 rounded-lg bg-rose-50 flex items-center justify-center text-rose-600" data-id="element-10388">
                  <SplitSquareHorizontal className="w-5 h-5" data-id="element-10389" />
                </div>
                <div data-id="element-10390">
                  <h4 className="font-bold text-slate-900" data-id="element-10391">{t.name}</h4>
                  <p className="text-xs text-slate-500" data-id="element-10392">
                    Кампания: {t.campaignId}
                  </p>
                </div>
              </div>
              <Badge variant={t.status === 'completed' ? 'success' : 'warning'} data-id="element-10393">
                {t.status}
              </Badge>
            </div>

            <div className="grid grid-cols-2 gap-4 mb-4" data-id="element-10394">
              <div className="bg-slate-50 p-3 rounded-lg border border-slate-100" data-id="element-10395">
                <div className="text-[10px] font-bold text-slate-500 uppercase mb-1" data-id="element-10396">
                  Вариант A ({t.split.split('/')[0]}%)
                </div>
                <div className="text-sm text-slate-700" data-id="element-10397">{t.variantA}</div>
              </div>
              <div className="bg-slate-50 p-3 rounded-lg border border-slate-100" data-id="element-10398">
                <div className="text-[10px] font-bold text-slate-500 uppercase mb-1" data-id="element-10399">
                  Вариант B ({t.split.split('/')[1]}%)
                </div>
                <div className="text-sm text-slate-700" data-id="element-10400">{t.variantB}</div>
              </div>
            </div>

            {t.winner && <div className="bg-emerald-50 text-emerald-700 p-2 rounded-lg text-xs font-medium flex items-center gap-2 mb-4" data-id="element-10401">
                <CheckCircle2 className="w-4 h-4" data-id="element-10402" /> Победитель: {t.winner}
              </div>}

            <div className="flex items-center justify-between text-[10px] text-slate-400 pt-3 border-t border-slate-100" data-id="element-10403">
              <span className="font-mono" data-id="element-10404">{t.id}</span>
              <span className="uppercase" data-id="element-10405">{t.type} test</span>
            </div>
          </Card>)}
      </div>
    </div>;
  // --- DETAIL MODAL ---
  const renderCampaignDetailModal = () => {
    if (!activeCampaignDetail) return null;
    const c = activeCampaignDetail;
    const typeInfo = campaignTypeConfig[c.type];
    const statusInfo = campaignStatusConfig[c.status];
    return <div className="fixed inset-0 z-50 flex items-center justify-center p-4 sm:p-6 bg-slate-900/50 backdrop-blur-sm" data-id="element-10406">
        <Card className="w-full max-w-6xl h-[90vh] flex flex-col shadow-2xl overflow-hidden" data-id="element-10407">
          {/* Header */}
          <div className="flex justify-between items-start p-6 border-b border-slate-200 bg-white shrink-0" data-id="element-10408">
            <div className="flex items-start gap-4" data-id="element-10409">
              <div className="w-12 h-12 rounded-xl bg-indigo-50 flex items-center justify-center text-indigo-600 shrink-0" data-id="element-10410">
                <Mail className="w-6 h-6" data-id="element-10411" />
              </div>
              <div data-id="element-10412">
                <div className="flex items-center gap-3 mb-1" data-id="element-10413">
                  <h2 className="text-xl font-bold text-slate-900" data-id="element-10414">{c.name}</h2>
                  <Badge variant={statusInfo?.variant || 'neutral'} data-id="element-10415">
                    {statusInfo?.label || c.status}
                  </Badge>
                  {c.statusReason && <span className="text-xs text-rose-600 flex items-center gap-1 bg-rose-50 px-2 py-0.5 rounded-full" data-id="element-10416">
                      <AlertTriangle className="w-3 h-3" data-id="element-10417" /> {c.statusReason}
                    </span>}
                </div>
                <div className="flex items-center gap-4 text-sm text-slate-500" data-id="element-10418">
                  <span className="font-mono text-xs bg-slate-100 px-1.5 py-0.5 rounded" data-id="element-10419">
                    {c.id}
                  </span>
                  <span className="flex items-center gap-1" data-id="element-10420">
                    <Clock className="w-3.5 h-3.5" data-id="element-10421" /> {c.date}
                  </span>
                  <span className="flex items-center gap-1" data-id="element-10422">
                    <Users className="w-3.5 h-3.5" data-id="element-10423" /> {c.segment}
                  </span>
                </div>
              </div>
            </div>
            <div className="flex items-center gap-2" data-id="element-10424">
              <Button variant="outline" size="sm" icon={<Eye className="w-4 h-4" data-id="element-10426" />} onClick={() => success('Превью открыто')} data-id="element-10425">
                Preview
              </Button>
              <Button variant="outline" size="sm" icon={<Edit className="w-4 h-4" data-id="element-10428" />} onClick={() => {
              setEditingCampaign(c);
              setCreateForm({
                name: c.name,
                type: c.type,
                subject: c.subject,
                previewText: c.previewText,
                templateId: c.templateId,
                segment: c.segment,
                sendDate: c.date !== 'Автоматически' ? c.date : ''
              });
              setShowCreateModal(true);
            }} data-id="element-10427">
                Edit
              </Button>
              <Button variant="ghost" size="sm" className="w-8 h-8 p-0" icon={<X className="w-5 h-5" data-id="element-10430" />} onClick={() => setActiveCampaignDetail(null)} data-id="element-10429" />
            </div>
          </div>

          {/* Tabs */}
          <div className="px-6 border-b border-slate-200 bg-slate-50 shrink-0" data-id="element-10431">
            <Tabs activeTab={detailTab} onChange={setDetailTab} tabs={[{
            id: 'overview',
            label: 'Основное'
          }, {
            id: 'template',
            label: 'Шаблон письма'
          }, {
            id: 'audience',
            label: 'Аудитория'
          }, {
            id: 'analytics',
            label: 'Аналитика'
          }, {
            id: 'conversions',
            label: 'Конверсии'
          }, {
            id: 'payment',
            label: 'Оплата'
          }, {
            id: 'timeline',
            label: 'Таймлайн'
          }, {
            id: 'logs',
            label: 'Логи'
          }, {
            id: 'abtest',
            label: 'A/B Тест'
          }]} data-id="element-10432" />
          </div>

          {/* Content Area */}
          <div className="flex-1 overflow-y-auto p-6 bg-slate-50" data-id="element-10433">
            {detailTab === 'overview' && <div className="space-y-6" data-id="element-10434">
                <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-10435">
                  <Card padding="md" className="shadow-none border-slate-200" data-id="element-10436">
                    <h3 className="text-sm font-bold text-slate-900 mb-4" data-id="element-10437">
                      Информация
                    </h3>
                    <div className="space-y-3" data-id="element-10438">
                      <div className="flex justify-between" data-id="element-10439">
                        <span className="text-xs text-slate-500" data-id="element-10440">ID</span>
                        <span className="text-xs font-mono text-slate-900" data-id="element-10441">
                          {c.id}
                        </span>
                      </div>
                      <div className="flex justify-between" data-id="element-10442">
                        <span className="text-xs text-slate-500" data-id="element-10443">Тип</span>
                        <span className="text-xs font-medium text-slate-900" data-id="element-10444">
                          {typeInfo?.label}
                        </span>
                      </div>
                      <div className="flex justify-between" data-id="element-10445">
                        <span className="text-xs text-slate-500" data-id="element-10446">Владелец</span>
                        <span className="text-xs font-medium text-slate-900" data-id="element-10447">
                          {c.advertiser}
                        </span>
                      </div>
                      <div className="flex justify-between" data-id="element-10448">
                        <span className="text-xs text-slate-500" data-id="element-10449">
                          Провайдер
                        </span>
                        <span className="text-xs font-medium text-slate-900" data-id="element-10450">
                          {c.provider}
                        </span>
                      </div>
                      <div className="flex justify-between" data-id="element-10451">
                        <span className="text-xs text-slate-500" data-id="element-10452">
                          Отправитель
                        </span>
                        <span className="text-xs font-medium text-slate-900" data-id="element-10453">
                          {c.senderIdentity}
                        </span>
                      </div>
                      <div className="flex justify-between" data-id="element-10454">
                        <span className="text-xs text-slate-500" data-id="element-10455">Шаблон</span>
                        <span className="text-xs font-medium text-indigo-600 cursor-pointer hover:underline" data-id="element-10456">
                          {c.templateId}
                        </span>
                      </div>
                    </div>
                  </Card>
                  <Card padding="md" className="shadow-none border-slate-200 md:col-span-2" data-id="element-10457">
                    <h3 className="text-sm font-bold text-slate-900 mb-4" data-id="element-10458">
                      Контент
                    </h3>
                    <div className="space-y-4" data-id="element-10459">
                      <div data-id="element-10460">
                        <div className="text-xs text-slate-500 mb-1" data-id="element-10461">
                          Тема письма (Subject)
                        </div>
                        <div className="text-sm font-medium text-slate-900 bg-slate-100 p-2 rounded" data-id="element-10462">
                          {c.subject}
                        </div>
                      </div>
                      <div data-id="element-10463">
                        <div className="text-xs text-slate-500 mb-1" data-id="element-10464">
                          Превью (Preheader)
                        </div>
                        <div className="text-sm text-slate-700 bg-slate-100 p-2 rounded" data-id="element-10465">
                          {c.previewText}
                        </div>
                      </div>
                    </div>
                  </Card>
                </div>

                <h3 className="text-lg font-bold text-slate-900 mt-8 mb-4" data-id="element-10466">
                  Быстрая статистика
                </h3>
                <div className="grid grid-cols-2 md:grid-cols-4 gap-4" data-id="element-10467">
                  <div className="bg-white p-4 rounded-xl border border-slate-200" data-id="element-10468">
                    <div className="text-xs text-slate-500 mb-1" data-id="element-10469">
                      Отправлено
                    </div>
                    <div className="text-2xl font-bold text-slate-900" data-id="element-10470">
                      {c.sent.toLocaleString('ru-RU')}
                    </div>
                  </div>
                  <div className="bg-white p-4 rounded-xl border border-slate-200" data-id="element-10471">
                    <div className="text-xs text-slate-500 mb-1" data-id="element-10472">Open Rate</div>
                    <div className="text-2xl font-bold text-blue-600" data-id="element-10473">
                      {c.openRate}
                    </div>
                  </div>
                  <div className="bg-white p-4 rounded-xl border border-slate-200" data-id="element-10474">
                    <div className="text-xs text-slate-500 mb-1" data-id="element-10475">CTR</div>
                    <div className="text-2xl font-bold text-purple-600" data-id="element-10476">
                      {c.ctr}
                    </div>
                  </div>
                  <div className="bg-white p-4 rounded-xl border border-slate-200" data-id="element-10477">
                    <div className="text-xs text-slate-500 mb-1" data-id="element-10478">Доход</div>
                    <div className="text-2xl font-bold text-emerald-600" data-id="element-10479">
                      {formatCurrency(c.revenue)}
                    </div>
                  </div>
                </div>
              </div>}

            {detailTab === 'analytics' && <div className="space-y-6" data-id="element-10480">
                <div className="grid grid-cols-2 md:grid-cols-4 gap-4" data-id="element-10481">
                  <Card padding="md" className="shadow-none border-slate-200" data-id="element-10482">
                    <div className="text-xs text-slate-500 mb-1" data-id="element-10483">
                      Доставлено
                    </div>
                    <div className="text-xl font-bold text-slate-900" data-id="element-10484">
                      {c.delivered.toLocaleString('ru-RU')}
                    </div>
                    <div className="text-[10px] text-emerald-600 mt-1" data-id="element-10485">
                      {(c.delivered / c.sent * 100 || 0).toFixed(1)}% Delivery
                      Rate
                    </div>
                  </Card>
                  <Card padding="md" className="shadow-none border-slate-200" data-id="element-10486">
                    <div className="text-xs text-slate-500 mb-1" data-id="element-10487">
                      Открытия (Unique)
                    </div>
                    <div className="text-xl font-bold text-blue-600" data-id="element-10488">
                      {c.opens.toLocaleString('ru-RU')}
                    </div>
                    <div className="text-[10px] text-slate-500 mt-1" data-id="element-10489">
                      Open Rate: {c.openRate}
                    </div>
                  </Card>
                  <Card padding="md" className="shadow-none border-slate-200" data-id="element-10490">
                    <div className="text-xs text-slate-500 mb-1" data-id="element-10491">
                      Клики (Unique)
                    </div>
                    <div className="text-xl font-bold text-purple-600" data-id="element-10492">
                      {c.clicks.toLocaleString('ru-RU')}
                    </div>
                    <div className="text-[10px] text-slate-500 mt-1" data-id="element-10493">
                      CTR: {c.ctr}
                    </div>
                  </Card>
                  <Card padding="md" className="shadow-none border-slate-200" data-id="element-10494">
                    <div className="text-xs text-slate-500 mb-1" data-id="element-10495">Конверсии</div>
                    <div className="text-xl font-bold text-amber-600" data-id="element-10496">
                      {c.conversions.toLocaleString('ru-RU')}
                    </div>
                    <div className="text-[10px] text-slate-500 mt-1" data-id="element-10497">
                      CR: {c.conversionRate}
                    </div>
                  </Card>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-3 gap-4" data-id="element-10498">
                  <Card padding="md" className="shadow-none border-slate-200 bg-orange-50/50" data-id="element-10499">
                    <div className="flex items-center gap-2 mb-2" data-id="element-10500">
                      <ArrowUpRight className="w-4 h-4 text-orange-500" data-id="element-10501" />
                      <div className="text-sm font-bold text-slate-900" data-id="element-10502">
                        Bounces
                      </div>
                    </div>
                    <div className="text-2xl font-bold text-orange-600" data-id="element-10503">
                      {c.bounce}
                    </div>
                    <div className="text-xs text-slate-500 mt-1" data-id="element-10504">
                      Rate: {c.bounceRate}
                    </div>
                  </Card>
                  <Card padding="md" className="shadow-none border-slate-200 bg-rose-50/50" data-id="element-10505">
                    <div className="flex items-center gap-2 mb-2" data-id="element-10506">
                      <ArrowDownRight className="w-4 h-4 text-rose-500" data-id="element-10507" />
                      <div className="text-sm font-bold text-slate-900" data-id="element-10508">
                        Unsubscribes
                      </div>
                    </div>
                    <div className="text-2xl font-bold text-rose-600" data-id="element-10509">
                      {c.unsubscribe}
                    </div>
                    <div className="text-xs text-slate-500 mt-1" data-id="element-10510">
                      Rate: {c.unsubscribeRate}
                    </div>
                  </Card>
                  <Card padding="md" className="shadow-none border-slate-200 bg-red-50/50" data-id="element-10511">
                    <div className="flex items-center gap-2 mb-2" data-id="element-10512">
                      <AlertTriangle className="w-4 h-4 text-red-500" data-id="element-10513" />
                      <div className="text-sm font-bold text-slate-900" data-id="element-10514">
                        Spam Complaints
                      </div>
                    </div>
                    <div className="text-2xl font-bold text-red-600" data-id="element-10515">
                      {c.spam}
                    </div>
                    <div className="text-xs text-slate-500 mt-1" data-id="element-10516">
                      Rate: {(c.spam / c.sent * 100 || 0).toFixed(3)}%
                    </div>
                  </Card>
                </div>

                <Card padding="md" className="shadow-none border-slate-200" data-id="element-10517">
                  <h3 className="text-sm font-bold text-slate-900 mb-4" data-id="element-10518">
                    Финансовая эффективность
                  </h3>
                  <div className="grid grid-cols-2 gap-4" data-id="element-10519">
                    <div data-id="element-10520">
                      <div className="text-xs text-slate-500 mb-1" data-id="element-10521">
                        Общий доход (Attributed)
                      </div>
                      <div className="text-2xl font-bold text-emerald-600" data-id="element-10522">
                        {formatCurrency(c.revenue)}
                      </div>
                    </div>
                    <div data-id="element-10523">
                      <div className="text-xs text-slate-500 mb-1" data-id="element-10524">
                        RPM (Доход на 1000 писем)
                      </div>
                      <div className="text-2xl font-bold text-emerald-600" data-id="element-10525">
                        {formatCurrency(c.rpm)}
                      </div>
                    </div>
                  </div>
                </Card>
              </div>}

            {detailTab === 'audience' && <div className="space-y-6" data-id="element-10526">
                <Card padding="md" className="shadow-none border-slate-200" data-id="element-10527">
                  <div className="flex justify-between items-start mb-6" data-id="element-10528">
                    <div data-id="element-10529">
                      <h3 className="text-lg font-bold text-slate-900" data-id="element-10530">
                        Сегмент: {c.segment}
                      </h3>
                      <p className="text-sm text-slate-500" data-id="element-10531">
                        Размер аудитории:{' '}
                        {c.audienceSize.toLocaleString('ru-RU')} пользователей
                      </p>
                    </div>
                    <Button variant="outline" size="sm" icon={<Users className="w-4 h-4" data-id="element-10533" />} onClick={() => success('Открыт сегмент')} data-id="element-10532">
                      Посмотреть сегмент
                    </Button>
                  </div>

                  <div className="bg-slate-100 rounded-lg p-4 mb-6" data-id="element-10534">
                    <h4 className="text-xs font-bold text-slate-700 uppercase tracking-wider mb-2" data-id="element-10535">
                      Правила сегментации
                    </h4>
                    <code className="text-sm text-slate-800 block whitespace-pre-wrap" data-id="element-10536">
                      {`SELECT * FROM users
WHERE last_login < NOW() - INTERVAL '30 days'
AND has_orders = false
AND is_subscribed_to_emails = true`}
                    </code>
                  </div>

                  <div className="grid grid-cols-2 gap-4" data-id="element-10537">
                    <div className="border border-slate-200 rounded-lg p-4" data-id="element-10538">
                      <h4 className="text-xs font-bold text-slate-700 uppercase tracking-wider mb-2" data-id="element-10539">
                        Исключения (Exclusions)
                      </h4>
                      <ul className="text-sm text-slate-600 space-y-1 list-disc list-inside pl-4" data-id="element-10540">
                        <li data-id="element-10541">Пользователи с активной подпиской Pro</li>
                        <li data-id="element-10542">
                          Пользователи, совершившие покупку за последние 7 дней
                        </li>
                      </ul>
                    </div>
                    <div className="border border-slate-200 rounded-lg p-4" data-id="element-10543">
                      <h4 className="text-xs font-bold text-slate-700 uppercase tracking-wider mb-2" data-id="element-10544">
                        Suppression Lists
                      </h4>
                      <ul className="text-sm text-slate-600 space-y-1 list-disc list-inside pl-4" data-id="element-10545">
                        <li data-id="element-10546">Global Bounces</li>
                        <li data-id="element-10547">Global Unsubscribes</li>
                        <li data-id="element-10548">Spam Complainers</li>
                      </ul>
                    </div>
                  </div>
                </Card>
              </div>}

            {detailTab === 'template' && <div className="space-y-6 h-full flex flex-col" data-id="element-10549">
                <div className="flex justify-between items-center" data-id="element-10550">
                  <div data-id="element-10551">
                    <h3 className="text-lg font-bold text-slate-900" data-id="element-10552">
                      Шаблон: {c.templateId}
                    </h3>
                    <p className="text-sm text-slate-500" data-id="element-10553">
                      Превью письма для десктопа и мобильных
                    </p>
                  </div>
                  <div className="flex gap-2" data-id="element-10554">
                    <Button variant="outline" size="sm" icon={<Monitor className="w-4 h-4" data-id="element-10556" />} data-id="element-10555">
                      Desktop
                    </Button>
                    <Button variant="outline" size="sm" icon={<Smartphone className="w-4 h-4" data-id="element-10558" />} data-id="element-10557">
                      Mobile
                    </Button>
                  </div>
                </div>

                <div className="flex-1 bg-slate-200 rounded-xl border border-slate-300 overflow-hidden flex items-center justify-center min-h-[400px] relative" data-id="element-10559">
                  <div className="w-[600px] h-[80%] bg-white shadow-xl rounded overflow-hidden flex flex-col" data-id="element-10560">
                    <div className="bg-slate-100 p-3 border-b border-slate-200 text-sm" data-id="element-10561">
                      <div data-id="element-10562">
                        <span className="text-slate-500 w-16 inline-block" data-id="element-10563">
                          From:
                        </span>{' '}
                        {c.senderIdentity}
                      </div>
                      <div data-id="element-10564">
                        <span className="text-slate-500 w-16 inline-block" data-id="element-10565">
                          Subject:
                        </span>{' '}
                        {c.subject}
                      </div>
                    </div>
                    <div className="flex-1 p-8 overflow-y-auto" data-id="element-10566">
                      <div className="max-w-md mx-auto text-center space-y-6" data-id="element-10567">
                        <div className="w-16 h-16 bg-indigo-100 rounded-full mx-auto flex items-center justify-center text-indigo-600 font-bold text-2xl" data-id="element-10568">
                          A
                        </div>
                        <h1 className="text-2xl font-bold text-slate-900" data-id="element-10569">
                          Здравствуйте, {'{{user.name}}'}!
                        </h1>
                        <p className="text-slate-600" data-id="element-10570">{c.previewText}</p>
                        <div className="w-full h-32 bg-slate-100 rounded-lg flex items-center justify-center text-slate-400" data-id="element-10571">
                          [Dynamic Content Block]
                        </div>
                        <Button variant="primary" size="lg" className="w-full" data-id="element-10572">
                          Call to Action
                        </Button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>}

            {detailTab === 'conversions' && <div className="space-y-6" data-id="element-10573">
                <Card padding="none" className="shadow-none border-slate-200 overflow-hidden" data-id="element-10574">
                  <div className="p-4 border-b border-slate-200 bg-white flex justify-between items-center" data-id="element-10575">
                    <h3 className="text-sm font-bold text-slate-900" data-id="element-10576">
                      Атрибуция конверсий (Last Click, 7 days)
                    </h3>
                    <Button variant="outline" size="sm" icon={<Download className="w-4 h-4" data-id="element-10578" />} data-id="element-10577">
                      Экспорт CSV
                    </Button>
                  </div>
                  <table className="w-full text-left whitespace-nowrap" data-id="element-10579">
                    <thead className="bg-slate-50 text-slate-500 border-b border-slate-200 text-[11px] uppercase tracking-wider" data-id="element-10580">
                      <tr data-id="element-10581">
                        <th className="px-4 py-3 font-medium" data-id="element-10582">Order ID</th>
                        <th className="px-4 py-3 font-medium" data-id="element-10583">User ID</th>
                        <th className="px-4 py-3 font-medium" data-id="element-10584">Дата/Время</th>
                        <th className="px-4 py-3 font-medium" data-id="element-10585">Услуга</th>
                        <th className="px-4 py-3 font-medium text-right" data-id="element-10586">
                          Доход
                        </th>
                      </tr>
                    </thead>
                    <tbody className="divide-y divide-slate-100" data-id="element-10587">
                      {[1, 2, 3, 4, 5].map(i => <tr key={i} className="hover:bg-slate-50" data-id="element-10588">
                          <td className="px-4 py-3 text-sm font-mono text-indigo-600 cursor-pointer hover:underline" data-id="element-10589">
                            ORD-2026-{8000 + i}
                          </td>
                          <td className="px-4 py-3 text-sm font-mono text-slate-600" data-id="element-10590">
                            USR-{1000 + i * 7}
                          </td>
                          <td className="px-4 py-3 text-xs text-slate-500" data-id="element-10591">
                            16.03.2026 14:{10 + i}
                          </td>
                          <td className="px-4 py-3 text-sm text-slate-900" data-id="element-10592">
                            Натальная карта Premium
                          </td>
                          <td className="px-4 py-3 text-sm font-bold text-emerald-600 text-right" data-id="element-10593">
                            3 900 ₽
                          </td>
                        </tr>)}
                    </tbody>
                  </table>
                  <div className="p-4 border-t border-slate-100 bg-slate-50 text-center text-sm text-slate-500" data-id="element-10594">
                    Показано 5 из {c.conversions} конверсий
                  </div>
                </Card>
              </div>}

            {detailTab === 'payment' && <div className="space-y-6" data-id="element-10595">
                <Card padding="md" className="shadow-none border-slate-200 max-w-2xl mx-auto" data-id="element-10596">
                  <div className="flex items-center justify-between mb-6" data-id="element-10597">
                    <h3 className="text-lg font-bold text-slate-900" data-id="element-10598">
                      Статус оплаты размещения
                    </h3>
                    <Badge variant={c.paymentStatus === 'paid' ? 'success' : c.paymentStatus === 'n/a' ? 'neutral' : 'warning'} data-id="element-10599">
                      {c.paymentStatus === 'paid' ? 'Оплачено' : c.paymentStatus === 'n/a' ? 'Не требуется' : 'Ожидает оплаты'}
                    </Badge>
                  </div>

                  {c.paymentStatus === 'paid' ? <div className="space-y-4" data-id="element-10600">
                      <div className="bg-emerald-50 border border-emerald-100 rounded-lg p-4 flex items-start gap-3" data-id="element-10601">
                        <CheckCircle2 className="w-5 h-5 text-emerald-600 mt-0.5" data-id="element-10602" />
                        <div data-id="element-10603">
                          <div className="font-bold text-emerald-800" data-id="element-10604">
                            Оплата получена
                          </div>
                          <div className="text-sm text-emerald-600 mt-1" data-id="element-10605">
                            Кампания допущена к отправке
                          </div>
                        </div>
                      </div>
                      <div className="grid grid-cols-2 gap-4 pt-4 border-t border-slate-100" data-id="element-10606">
                        <div data-id="element-10607">
                          <div className="text-xs text-slate-500 mb-1" data-id="element-10608">
                            Рекламодатель
                          </div>
                          <div className="text-sm font-medium text-slate-900" data-id="element-10609">
                            {c.advertiser}
                          </div>
                        </div>
                        <div data-id="element-10610">
                          <div className="text-xs text-slate-500 mb-1" data-id="element-10611">
                            Сумма
                          </div>
                          <div className="text-sm font-bold text-slate-900" data-id="element-10612">
                            40 000 ₽
                          </div>
                        </div>
                        <div data-id="element-10613">
                          <div className="text-xs text-slate-500 mb-1" data-id="element-10614">
                            Invoice ID
                          </div>
                          <div className="text-sm font-mono text-indigo-600 cursor-pointer hover:underline" data-id="element-10615">
                            INV-2026-03-15
                          </div>
                        </div>
                        <div data-id="element-10616">
                          <div className="text-xs text-slate-500 mb-1" data-id="element-10617">
                            Payment ID
                          </div>
                          <div className="text-sm font-mono text-slate-600" data-id="element-10618">
                            ch_1Oxyz2e...
                          </div>
                        </div>
                      </div>
                      <Button variant="outline" className="w-full mt-4" icon={<FileText className="w-4 h-4" data-id="element-10620" />} data-id="element-10619">
                        Скачать чек
                      </Button>
                    </div> : <div className="text-center py-8 text-slate-500" data-id="element-10621">
                      Для системных и внутренних кампаний оплата не требуется.
                    </div>}
                </Card>
              </div>}

            {detailTab === 'timeline' && <div className="space-y-6 max-w-2xl mx-auto" data-id="element-10622">
                <div className="relative border-l-2 border-slate-200 ml-4 space-y-8 pb-8" data-id="element-10623">
                  <div className="relative pl-6" data-id="element-10624">
                    <div className="absolute -left-[9px] top-1 w-4 h-4 rounded-full bg-emerald-500 border-4 border-slate-50" data-id="element-10625" />
                    <div className="text-xs text-slate-500 mb-1" data-id="element-10626">
                      15.03.2026 10:45
                    </div>
                    <div className="text-sm font-bold text-slate-900" data-id="element-10627">
                      Отправка завершена
                    </div>
                    <div className="text-sm text-slate-600 mt-1" data-id="element-10628">
                      Успешно отправлено 45,000 писем.
                    </div>
                  </div>
                  <div className="relative pl-6" data-id="element-10629">
                    <div className="absolute -left-[9px] top-1 w-4 h-4 rounded-full bg-blue-500 border-4 border-slate-50" data-id="element-10630" />
                    <div className="text-xs text-slate-500 mb-1" data-id="element-10631">
                      15.03.2026 10:00
                    </div>
                    <div className="text-sm font-bold text-slate-900" data-id="element-10632">
                      Отправка начата
                    </div>
                    <div className="text-sm text-slate-600 mt-1" data-id="element-10633">
                      Кампания передана провайдеру SendGrid.
                    </div>
                  </div>
                  <div className="relative pl-6" data-id="element-10634">
                    <div className="absolute -left-[9px] top-1 w-4 h-4 rounded-full bg-amber-500 border-4 border-slate-50" data-id="element-10635" />
                    <div className="text-xs text-slate-500 mb-1" data-id="element-10636">
                      14.03.2026 18:30
                    </div>
                    <div className="text-sm font-bold text-slate-900" data-id="element-10637">
                      Поставлено в расписание (Scheduled)
                    </div>
                    <div className="text-sm text-slate-600 mt-1" data-id="element-10638">
                      Пользователь admin@astriqo.com запланировал отправку.
                    </div>
                  </div>
                  <div className="relative pl-6" data-id="element-10639">
                    <div className="absolute -left-[9px] top-1 w-4 h-4 rounded-full bg-slate-300 border-4 border-slate-50" data-id="element-10640" />
                    <div className="text-xs text-slate-500 mb-1" data-id="element-10641">
                      14.03.2026 15:20
                    </div>
                    <div className="text-sm font-bold text-slate-900" data-id="element-10642">
                      Кампания создана
                    </div>
                    <div className="text-sm text-slate-600 mt-1" data-id="element-10643">
                      Создан черновик.
                    </div>
                  </div>
                </div>
              </div>}

            {detailTab === 'logs' && <div className="space-y-4" data-id="element-10644">
                <div className="flex justify-between items-center bg-slate-900 text-white p-4 rounded-t-xl" data-id="element-10645">
                  <div className="flex items-center gap-2" data-id="element-10646">
                    <TerminalSquare className="w-5 h-5 text-slate-400" data-id="element-10647" />
                    <span className="font-mono text-sm" data-id="element-10648">
                      Provider Logs: {c.provider}
                    </span>
                  </div>
                  <Button variant="outline" size="sm" className="border-slate-700 text-slate-300 hover:bg-slate-800 hover:text-white" data-id="element-10649">
                    Download Logs
                  </Button>
                </div>
                <div className="bg-slate-950 text-emerald-400 p-4 rounded-b-xl font-mono text-xs overflow-x-auto h-[400px] overflow-y-auto space-y-2" data-id="element-10650">
                  <div data-id="element-10651">
                    [2026-03-15 10:00:01] INFO: Initiating batch send for
                    EC-2026-001 (45000 recipients)
                  </div>
                  <div data-id="element-10652">
                    [2026-03-15 10:00:05] INFO: Batch 1/45 dispatched to
                    SendGrid API (Status: 202 Accepted)
                  </div>
                  <div data-id="element-10653">
                    [2026-03-15 10:00:12] INFO: Batch 2/45 dispatched to
                    SendGrid API (Status: 202 Accepted)
                  </div>
                  <div className="text-rose-400" data-id="element-10654">
                    [2026-03-15 10:00:18] WARN: Rate limit approaching.
                    Throttling requests.
                  </div>
                  <div data-id="element-10655">
                    [2026-03-15 10:00:25] INFO: Batch 3/45 dispatched to
                    SendGrid API (Status: 202 Accepted)
                  </div>
                  <div className="text-slate-500" data-id="element-10656">
                    ... 40 similar log entries ...
                  </div>
                  <div data-id="element-10657">[2026-03-15 10:45:12] INFO: Final batch dispatched.</div>
                  <div data-id="element-10658">
                    [2026-03-15 10:45:15] INFO: Campaign EC-2026-001 processing
                    completed.
                  </div>
                  <div className="text-blue-400" data-id="element-10659">
                    [2026-03-15 10:46:00] WEBHOOK: Received 150 delivery events
                  </div>
                  <div className="text-blue-400" data-id="element-10660">
                    [2026-03-15 10:46:05] WEBHOOK: Received 45 open events
                  </div>
                  <div className="text-orange-400" data-id="element-10661">
                    [2026-03-15 10:46:10] WEBHOOK: Received 2 bounce events
                    (Hard bounce)
                  </div>
                </div>
              </div>}

            {detailTab === 'abtest' && <div className="space-y-6 max-w-3xl mx-auto text-center py-12" data-id="element-10662">
                {c.abTestId ? <div data-id="element-10663">
                    <SplitSquareHorizontal className="w-16 h-16 text-indigo-200 mx-auto mb-4" data-id="element-10664" />
                    <h3 className="text-xl font-bold text-slate-900 mb-2" data-id="element-10665">
                      A/B Тест активен
                    </h3>
                    <p className="text-slate-500 mb-6" data-id="element-10666">
                      Эта кампания участвует в сплит-тестировании {c.abTestId}.
                    </p>
                    <Button variant="primary" onClick={() => {
                setActiveCampaignDetail(null);
                setActiveTab('abtests');
              }} data-id="element-10667">
                      Перейти к результатам теста
                    </Button>
                  </div> : <div data-id="element-10668">
                    <SplitSquareHorizontal className="w-16 h-16 text-slate-200 mx-auto mb-4" data-id="element-10669" />
                    <h3 className="text-xl font-bold text-slate-900 mb-2" data-id="element-10670">
                      Нет активных A/B тестов
                    </h3>
                    <p className="text-slate-500 mb-6" data-id="element-10671">
                      Для этой кампании не настроено сплит-тестирование.
                    </p>
                    <Button variant="outline" data-id="element-10672">Настроить A/B тест</Button>
                  </div>}
              </div>}
          </div>
        </Card>
      </div>;
  };
  // --- CREATE MODAL ---
  const renderCreateModal = () => {
    if (!showCreateModal) return null;
    return <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-slate-900/50 backdrop-blur-sm" data-id="element-10673">
        <Card className="w-full max-w-2xl max-h-[90vh] overflow-y-auto shadow-2xl" data-id="element-10674">
          <div className="flex justify-between items-center mb-6" data-id="element-10675">
            <div data-id="element-10676">
              <h3 className="text-lg font-bold text-slate-900" data-id="element-10677">
                {editingCampaign ? 'Редактирование кампании' : 'Новая email-кампания'}
              </h3>
              <p className="text-sm text-slate-500" data-id="element-10678">
                Создание и настройка рассылки
              </p>
            </div>
            <Button variant="ghost" size="sm" icon={<X className="w-5 h-5" data-id="element-10680" />} onClick={() => setShowCreateModal(false)} data-id="element-10679" />
          </div>

          <div className="space-y-6" data-id="element-10681">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-10682">
              <div data-id="element-10683">
                <label className="block text-xs font-medium text-slate-700 mb-1" data-id="element-10684">
                  Название кампании (внутреннее)
                </label>
                <input type="text" placeholder="Например: Промо Соляр Май" className="w-full rounded-lg border border-slate-200 px-3 py-2 text-sm focus:outline-none focus:border-indigo-500" value={createForm.name} onChange={e => setCreateForm({
                ...createForm,
                name: e.target.value
              })} data-id="element-10685" />
              </div>
              <div data-id="element-10686">
                <label className="block text-xs font-medium text-slate-700 mb-1" data-id="element-10687">
                  Тип кампании
                </label>
                <select className="w-full rounded-lg border border-slate-200 px-3 py-2 text-sm focus:outline-none focus:border-indigo-500" value={createForm.type} onChange={e => setCreateForm({
                ...createForm,
                type: e.target.value
              })} data-id="element-10688">
                  <option value="promotional" data-id="element-10689">Промо (Promotional)</option>
                  <option value="digest" data-id="element-10690">Дайджест (Newsletter)</option>
                  <option value="paid_placement" data-id="element-10691">
                    Платное размещение (Paid)
                  </option>
                  <option value="system" data-id="element-10692">Системное (System)</option>
                </select>
              </div>
            </div>

            <div className="border-t border-slate-100 pt-4" data-id="element-10693">
              <h4 className="text-sm font-bold text-slate-900 mb-3" data-id="element-10694">
                Контент письма
              </h4>
              <div className="space-y-4" data-id="element-10695">
                <div data-id="element-10696">
                  <label className="block text-xs font-medium text-slate-700 mb-1" data-id="element-10697">
                    Тема письма (Subject)
                  </label>
                  <input type="text" placeholder="Привлекательный заголовок..." className="w-full rounded-lg border border-slate-200 px-3 py-2 text-sm focus:outline-none focus:border-indigo-500" value={createForm.subject} onChange={e => setCreateForm({
                  ...createForm,
                  subject: e.target.value
                })} data-id="element-10698" />
                </div>
                <div data-id="element-10699">
                  <label className="block text-xs font-medium text-slate-700 mb-1" data-id="element-10700">
                    Превью текст (Preheader)
                  </label>
                  <input type="text" placeholder="Текст, который виден в списке писем..." className="w-full rounded-lg border border-slate-200 px-3 py-2 text-sm focus:outline-none focus:border-indigo-500" value={createForm.previewText} onChange={e => setCreateForm({
                  ...createForm,
                  previewText: e.target.value
                })} data-id="element-10701" />
                </div>
                <div data-id="element-10702">
                  <label className="block text-xs font-medium text-slate-700 mb-1" data-id="element-10703">
                    Шаблон (Template ID)
                  </label>
                  <select className="w-full rounded-lg border border-slate-200 px-3 py-2 text-sm focus:outline-none focus:border-indigo-500" value={createForm.templateId} onChange={e => setCreateForm({
                  ...createForm,
                  templateId: e.target.value
                })} data-id="element-10704">
                    <option value="TPL-001" data-id="element-10705">TPL-001: Стандартный промо</option>
                    <option value="TPL-002" data-id="element-10706">
                      TPL-002: Ежемесячный дайджест
                    </option>
                    <option value="TPL-005" data-id="element-10707">TPL-005: Скидка / Акция</option>
                  </select>
                </div>
              </div>
            </div>

            <div className="border-t border-slate-100 pt-4" data-id="element-10708">
              <h4 className="text-sm font-bold text-slate-900 mb-3" data-id="element-10709">
                Аудитория и отправка
              </h4>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-10710">
                <div data-id="element-10711">
                  <label className="block text-xs font-medium text-slate-700 mb-1" data-id="element-10712">
                    Сегмент получателей
                  </label>
                  <select className="w-full rounded-lg border border-slate-200 px-3 py-2 text-sm focus:outline-none focus:border-indigo-500" value={createForm.segment} onChange={e => setCreateForm({
                  ...createForm,
                  segment: e.target.value
                })} data-id="element-10713">
                    <option value="Все активные пользователи (~45k)" data-id="element-10714">
                      Все активные пользователи (~45k)
                    </option>
                    <option value="VIP клиенты (~1.2k)" data-id="element-10715">
                      VIP клиенты (~1.2k)
                    </option>
                    <option value="Пользователи без заказа (~12k)" data-id="element-10716">
                      Пользователи без заказа (~12k)
                    </option>
                  </select>
                </div>
                <div data-id="element-10717">
                  <label className="block text-xs font-medium text-slate-700 mb-1" data-id="element-10718">
                    Дата и время отправки
                  </label>
                  <input type="datetime-local" className="w-full rounded-lg border border-slate-200 px-3 py-2 text-sm focus:outline-none focus:border-indigo-500" value={createForm.sendDate} onChange={e => setCreateForm({
                  ...createForm,
                  sendDate: e.target.value
                })} data-id="element-10719" />
                </div>
              </div>
            </div>
          </div>

          <div className="flex justify-between items-center mt-8 pt-4 border-t border-slate-100" data-id="element-10720">
            <Button variant="outline" icon={<SplitSquareHorizontal className="w-4 h-4" data-id="element-10722" />} data-id="element-10721">
              Добавить A/B тест
            </Button>
            <div className="flex gap-3" data-id="element-10723">
              <Button variant="outline" onClick={() => setShowCreateModal(false)} data-id="element-10724">
                Отмена
              </Button>
              <Button variant="primary" onClick={() => {
              if (!createForm.name || !createForm.subject) {
                success('Заполните обязательные поля');
                return;
              }
              if (editingCampaign) {
                setCampaigns(campaigns.map(c => c.id === editingCampaign.id ? {
                  ...c,
                  ...createForm,
                  date: createForm.sendDate || c.date
                } : c));
                success('Кампания обновлена');
              } else {
                const newCampaign = {
                  id: `EC-2026-${Math.floor(Math.random() * 1000).toString().padStart(3, '0')}`,
                  name: createForm.name,
                  type: createForm.type,
                  advertiser: 'Astriqo',
                  segment: createForm.segment,
                  audienceSize: createForm.segment.includes('45k') ? 45000 : createForm.segment.includes('1.2k') ? 1200 : 12000,
                  date: createForm.sendDate ? new Date(createForm.sendDate).toLocaleString('ru-RU') : 'Не задано',
                  status: 'draft',
                  sent: 0,
                  delivered: 0,
                  opens: 0,
                  openRate: '0%',
                  clicks: 0,
                  ctr: '0%',
                  conversions: 0,
                  conversionRate: '0%',
                  revenue: 0,
                  rpm: 0,
                  bounce: 0,
                  bounceRate: '0%',
                  unsubscribe: 0,
                  unsubscribeRate: '0%',
                  spam: 0,
                  paymentStatus: 'n/a',
                  templateId: createForm.templateId,
                  subject: createForm.subject,
                  previewText: createForm.previewText,
                  abTestId: null,
                  automationId: null,
                  provider: 'SendGrid',
                  senderIdentity: 'news@astriqo.com'
                };
                setCampaigns([newCampaign, ...campaigns]);
                success('Кампания сохранена как черновик');
              }
              setShowCreateModal(false);
            }} data-id="element-10725">
                {editingCampaign ? 'Сохранить изменения' : 'Сохранить черновик'}
              </Button>
            </div>
          </div>
        </Card>
      </div>;
  };
  // --- TEMPLATE DETAIL MODAL ---
  const renderTemplateDetailModal = () => {
    if (!activeTemplateDetail) return null;
    const t = activeTemplateDetail;
    return <div className="fixed inset-0 z-50 flex items-center justify-center p-4 sm:p-6 bg-slate-900/50 backdrop-blur-sm" data-id="element-10726">
        <Card className="w-full max-w-4xl max-h-[90vh] flex flex-col shadow-2xl overflow-hidden" data-id="element-10727">
          <div className="flex justify-between items-start p-6 border-b border-slate-200 bg-white shrink-0" data-id="element-10728">
            <div className="flex items-start gap-4" data-id="element-10729">
              <div className="w-12 h-12 rounded-xl bg-indigo-50 flex items-center justify-center text-indigo-600 shrink-0" data-id="element-10730">
                <LayoutList className="w-6 h-6" data-id="element-10731" />
              </div>
              <div data-id="element-10732">
                <div className="flex items-center gap-3 mb-1" data-id="element-10733">
                  <h2 className="text-xl font-bold text-slate-900" data-id="element-10734">
                    {templateEditMode ? t.id === 'NEW' ? 'Создание шаблона' : 'Редактирование шаблона' : t.name}
                  </h2>
                  {!templateEditMode && <Badge variant={t.status === 'active' ? 'success' : 'neutral'} data-id="element-10735">
                      {t.status}
                    </Badge>}
                </div>
                {!templateEditMode && <div className="flex items-center gap-4 text-sm text-slate-500" data-id="element-10736">
                    <span className="font-mono text-xs bg-slate-100 px-1.5 py-0.5 rounded" data-id="element-10737">
                      {t.id}
                    </span>
                    <span data-id="element-10738">v{t.version}</span>
                    <span data-id="element-10739">{t.updatedAt}</span>
                  </div>}
              </div>
            </div>
            <div className="flex items-center gap-2" data-id="element-10740">
              {!templateEditMode && <Button variant="outline" size="sm" icon={<Edit className="w-4 h-4" data-id="element-10742" />} onClick={() => {
              setTemplateForm({
                name: t.name,
                type: t.type,
                subject: t.subject,
                previewText: t.previewText
              });
              setTemplateEditMode(true);
            }} data-id="element-10741">
                  Редактировать
                </Button>}
              <Button variant="ghost" size="sm" className="w-8 h-8 p-0" icon={<X className="w-5 h-5" data-id="element-10744" />} onClick={() => setActiveTemplateDetail(null)} data-id="element-10743" />
            </div>
          </div>

          <div className="flex-1 overflow-y-auto p-6 bg-slate-50" data-id="element-10745">
            {templateEditMode ? <div className="space-y-6 max-w-2xl mx-auto" data-id="element-10746">
                <div data-id="element-10747">
                  <label className="block text-sm font-medium text-slate-700 mb-1" data-id="element-10748">
                    Название шаблона
                  </label>
                  <input type="text" value={templateForm.name} onChange={e => setTemplateForm({
                ...templateForm,
                name: e.target.value
              })} className="w-full rounded-lg border border-slate-200 px-4 py-2 text-sm focus:outline-none focus:border-indigo-500" data-id="element-10749" />
                </div>
                <div data-id="element-10750">
                  <label className="block text-sm font-medium text-slate-700 mb-1" data-id="element-10751">
                    Тип
                  </label>
                  <select value={templateForm.type} onChange={e => setTemplateForm({
                ...templateForm,
                type: e.target.value
              })} className="w-full rounded-lg border border-slate-200 px-4 py-2 text-sm focus:outline-none focus:border-indigo-500" data-id="element-10752">
                    <option value="promo" data-id="element-10753">Промо</option>
                    <option value="newsletter" data-id="element-10754">Дайджест</option>
                    <option value="transactional" data-id="element-10755">Транзакционное</option>
                  </select>
                </div>
                <div data-id="element-10756">
                  <label className="block text-sm font-medium text-slate-700 mb-1" data-id="element-10757">
                    Тема по умолчанию
                  </label>
                  <input type="text" value={templateForm.subject} onChange={e => setTemplateForm({
                ...templateForm,
                subject: e.target.value
              })} className="w-full rounded-lg border border-slate-200 px-4 py-2 text-sm focus:outline-none focus:border-indigo-500" data-id="element-10758" />
                </div>
                <div data-id="element-10759">
                  <label className="block text-sm font-medium text-slate-700 mb-1" data-id="element-10760">
                    Превью текст
                  </label>
                  <input type="text" value={templateForm.previewText} onChange={e => setTemplateForm({
                ...templateForm,
                previewText: e.target.value
              })} className="w-full rounded-lg border border-slate-200 px-4 py-2 text-sm focus:outline-none focus:border-indigo-500" data-id="element-10761" />
                </div>
                <div className="pt-4 border-t border-slate-200 flex justify-end gap-3" data-id="element-10762">
                  <Button variant="outline" onClick={() => {
                if (t.id === 'NEW') setActiveTemplateDetail(null);else setTemplateEditMode(false);
              }} data-id="element-10763">
                    Отмена
                  </Button>
                  <Button variant="primary" onClick={() => {
                success('Шаблон сохранен');
                setActiveTemplateDetail(null);
              }} data-id="element-10764">
                    Сохранить
                  </Button>
                </div>
              </div> : <div className="space-y-6" data-id="element-10765">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-10766">
                  <Card padding="md" className="shadow-none border-slate-200" data-id="element-10767">
                    <h3 className="text-sm font-bold text-slate-900 mb-4" data-id="element-10768">
                      Информация
                    </h3>
                    <div className="space-y-3" data-id="element-10769">
                      <div className="flex justify-between" data-id="element-10770">
                        <span className="text-xs text-slate-500" data-id="element-10771">Тип</span>
                        <span className="text-xs font-medium text-slate-900" data-id="element-10772">
                          {t.type}
                        </span>
                      </div>
                      <div className="flex justify-between" data-id="element-10773">
                        <span className="text-xs text-slate-500" data-id="element-10774">Тема</span>
                        <span className="text-xs font-medium text-slate-900" data-id="element-10775">
                          {t.subject}
                        </span>
                      </div>
                      <div className="flex justify-between" data-id="element-10776">
                        <span className="text-xs text-slate-500" data-id="element-10777">Превью</span>
                        <span className="text-xs font-medium text-slate-900" data-id="element-10778">
                          {t.previewText}
                        </span>
                      </div>
                    </div>
                  </Card>
                  <Card padding="md" className="shadow-none border-slate-200 flex flex-col items-center justify-center text-center" data-id="element-10779">
                    <Monitor className="w-12 h-12 text-slate-300 mb-4" data-id="element-10780" />
                    <p className="text-sm text-slate-500 mb-4" data-id="element-10781">
                      HTML редактор доступен в полной версии
                    </p>
                    <Button variant="outline" icon={<Code className="w-4 h-4" data-id="element-10783" />} data-id="element-10782">
                      Открыть в редакторе
                    </Button>
                  </Card>
                </div>
              </div>}
          </div>
        </Card>
      </div>;
  };
  // --- SEGMENT DETAIL MODAL ---
  const renderSegmentDetailModal = () => {
    if (!activeSegmentDetail) return null;
    const s = activeSegmentDetail;
    return <div className="fixed inset-0 z-50 flex items-center justify-center p-4 sm:p-6 bg-slate-900/50 backdrop-blur-sm" data-id="element-10784">
        <Card className="w-full max-w-4xl max-h-[90vh] flex flex-col shadow-2xl overflow-hidden" data-id="element-10785">
          <div className="flex justify-between items-start p-6 border-b border-slate-200 bg-white shrink-0" data-id="element-10786">
            <div className="flex items-start gap-4" data-id="element-10787">
              <div className="w-12 h-12 rounded-xl bg-emerald-50 flex items-center justify-center text-emerald-600 shrink-0" data-id="element-10788">
                <Users className="w-6 h-6" data-id="element-10789" />
              </div>
              <div data-id="element-10790">
                <div className="flex items-center gap-3 mb-1" data-id="element-10791">
                  <h2 className="text-xl font-bold text-slate-900" data-id="element-10792">
                    {segmentEditMode ? s.id === 'NEW' ? 'Создание сегмента' : 'Редактирование сегмента' : s.name}
                  </h2>
                  {!segmentEditMode && <Badge variant={s.type === 'dynamic' ? 'pro' : 'neutral'} data-id="element-10793">
                      {s.type}
                    </Badge>}
                </div>
                {!segmentEditMode && <div className="flex items-center gap-4 text-sm text-slate-500" data-id="element-10794">
                    <span className="font-mono text-xs bg-slate-100 px-1.5 py-0.5 rounded" data-id="element-10795">
                      {s.id}
                    </span>
                    <span data-id="element-10796">{s.updatedAt}</span>
                  </div>}
              </div>
            </div>
            <div className="flex items-center gap-2" data-id="element-10797">
              {!segmentEditMode && <Button variant="outline" size="sm" icon={<Edit className="w-4 h-4" data-id="element-10799" />} onClick={() => {
              setSegmentForm({
                name: s.name,
                type: s.type,
                rules: s.rules
              });
              setSegmentEditMode(true);
            }} data-id="element-10798">
                  Редактировать
                </Button>}
              <Button variant="ghost" size="sm" className="w-8 h-8 p-0" icon={<X className="w-5 h-5" data-id="element-10801" />} onClick={() => setActiveSegmentDetail(null)} data-id="element-10800" />
            </div>
          </div>

          <div className="flex-1 overflow-y-auto p-6 bg-slate-50" data-id="element-10802">
            {segmentEditMode ? <div className="space-y-6 max-w-2xl mx-auto" data-id="element-10803">
                <div data-id="element-10804">
                  <label className="block text-sm font-medium text-slate-700 mb-1" data-id="element-10805">
                    Название сегмента
                  </label>
                  <input type="text" value={segmentForm.name} onChange={e => setSegmentForm({
                ...segmentForm,
                name: e.target.value
              })} className="w-full rounded-lg border border-slate-200 px-4 py-2 text-sm focus:outline-none focus:border-indigo-500" data-id="element-10806" />
                </div>
                <div data-id="element-10807">
                  <label className="block text-sm font-medium text-slate-700 mb-1" data-id="element-10808">
                    Тип сегмента
                  </label>
                  <select value={segmentForm.type} onChange={e => setSegmentForm({
                ...segmentForm,
                type: e.target.value
              })} className="w-full rounded-lg border border-slate-200 px-4 py-2 text-sm focus:outline-none focus:border-indigo-500" data-id="element-10809">
                    <option value="dynamic" data-id="element-10810">
                      Динамический (обновляется автоматически)
                    </option>
                    <option value="static" data-id="element-10811">
                      Статический (фиксированный список)
                    </option>
                  </select>
                </div>
                <div data-id="element-10812">
                  <label className="block text-sm font-medium text-slate-700 mb-1" data-id="element-10813">
                    Правила (SQL / JSON)
                  </label>
                  <textarea value={segmentForm.rules} onChange={e => setSegmentForm({
                ...segmentForm,
                rules: e.target.value
              })} rows={6} className="w-full rounded-lg border border-slate-200 px-4 py-2 text-sm font-mono focus:outline-none focus:border-indigo-500" placeholder="last_login < 30 days..." data-id="element-10814" />
                </div>
                <div className="pt-4 border-t border-slate-200 flex justify-end gap-3" data-id="element-10815">
                  <Button variant="outline" onClick={() => {
                if (s.id === 'NEW') setActiveSegmentDetail(null);else setSegmentEditMode(false);
              }} data-id="element-10816">
                    Отмена
                  </Button>
                  <Button variant="primary" onClick={() => {
                success('Сегмент сохранен');
                setActiveSegmentDetail(null);
              }} data-id="element-10817">
                    Сохранить
                  </Button>
                </div>
              </div> : <div className="space-y-6" data-id="element-10818">
                <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-10819">
                  <Card padding="md" className="shadow-none border-slate-200 md:col-span-1 flex flex-col items-center justify-center text-center" data-id="element-10820">
                    <div className="text-sm text-slate-500 mb-2" data-id="element-10821">
                      Размер аудитории
                    </div>
                    <div className="text-4xl font-bold text-slate-900 mb-2" data-id="element-10822">
                      {s.size.toLocaleString('ru-RU')}
                    </div>
                    <div className="text-xs text-slate-400" data-id="element-10823">пользователей</div>
                    <Button variant="outline" size="sm" className="mt-4 w-full" data-id="element-10824">
                      Экспорт списка
                    </Button>
                  </Card>
                  <Card padding="md" className="shadow-none border-slate-200 md:col-span-2" data-id="element-10825">
                    <h3 className="text-sm font-bold text-slate-900 mb-4" data-id="element-10826">
                      Правила сегментации
                    </h3>
                    <div className="bg-slate-100 rounded-lg p-4" data-id="element-10827">
                      <code className="text-sm text-slate-800 block whitespace-pre-wrap" data-id="element-10828">
                        {s.rules}
                      </code>
                    </div>
                  </Card>
                </div>
              </div>}
          </div>
        </Card>
      </div>;
  };
  // --- AUTOMATION DETAIL MODAL ---
  const renderAutomationDetailModal = () => {
    if (!activeAutomationDetail) return null;
    const a = activeAutomationDetail;
    return <div className="fixed inset-0 z-50 flex items-center justify-center p-4 sm:p-6 bg-slate-900/50 backdrop-blur-sm" data-id="element-10829">
        <Card className="w-full max-w-5xl max-h-[90vh] flex flex-col shadow-2xl overflow-hidden" data-id="element-10830">
          <div className="flex justify-between items-start p-6 border-b border-slate-200 bg-white shrink-0" data-id="element-10831">
            <div className="flex items-start gap-4" data-id="element-10832">
              <div className="w-12 h-12 rounded-xl bg-amber-50 flex items-center justify-center text-amber-600 shrink-0" data-id="element-10833">
                <Zap className="w-6 h-6" data-id="element-10834" />
              </div>
              <div data-id="element-10835">
                <div className="flex items-center gap-3 mb-1" data-id="element-10836">
                  <h2 className="text-xl font-bold text-slate-900" data-id="element-10837">
                    {automationEditMode ? a.id === 'NEW' ? 'Создание автоматизации' : 'Редактирование автоматизации' : a.name}
                  </h2>
                  {!automationEditMode && <Badge variant={a.status === 'active' ? 'success' : 'neutral'} data-id="element-10838">
                      {a.status}
                    </Badge>}
                </div>
                {!automationEditMode && <div className="flex items-center gap-4 text-sm text-slate-500" data-id="element-10839">
                    <span className="font-mono text-xs bg-slate-100 px-1.5 py-0.5 rounded" data-id="element-10840">
                      {a.id}
                    </span>
                    <span className="flex items-center gap-1" data-id="element-10841">
                      <Target className="w-3.5 h-3.5" data-id="element-10842" /> {a.trigger}
                    </span>
                  </div>}
              </div>
            </div>
            <div className="flex items-center gap-2" data-id="element-10843">
              {!automationEditMode && <Button variant="outline" size="sm" icon={<Edit className="w-4 h-4" data-id="element-10845" />} onClick={() => setAutomationEditMode(true)} data-id="element-10844">
                  Редактировать
                </Button>}
              <Button variant="ghost" size="sm" className="w-8 h-8 p-0" icon={<X className="w-5 h-5" data-id="element-10847" />} onClick={() => setActiveAutomationDetail(null)} data-id="element-10846" />
            </div>
          </div>

          <div className="flex-1 overflow-y-auto p-6 bg-slate-50" data-id="element-10848">
            {automationEditMode ? <div className="flex flex-col items-center justify-center h-full text-center py-12" data-id="element-10849">
                <Layers className="w-16 h-16 text-slate-300 mb-4" data-id="element-10850" />
                <h3 className="text-xl font-bold text-slate-900 mb-2" data-id="element-10851">
                  Визуальный редактор автоматизаций
                </h3>
                <p className="text-slate-500 mb-6 max-w-md mx-auto" data-id="element-10852">
                  Конструктор цепочек писем (Flow Builder) доступен в
                  расширенной версии платформы.
                </p>
                <div className="flex gap-3" data-id="element-10853">
                  <Button variant="outline" onClick={() => {
                if (a.id === 'NEW') setActiveAutomationDetail(null);else setAutomationEditMode(false);
              }} data-id="element-10854">
                    Отмена
                  </Button>
                  <Button variant="primary" onClick={() => {
                success('Изменения сохранены');
                setActiveAutomationDetail(null);
              }} data-id="element-10855">
                    Сохранить
                  </Button>
                </div>
              </div> : <div className="space-y-6" data-id="element-10856">
                <div className="grid grid-cols-1 md:grid-cols-3 gap-4" data-id="element-10857">
                  <Card padding="md" className="shadow-none border-slate-200" data-id="element-10858">
                    <div className="text-xs text-slate-500 mb-1" data-id="element-10859">
                      Шагов в цепочке
                    </div>
                    <div className="text-2xl font-bold text-slate-900" data-id="element-10860">
                      {a.steps}
                    </div>
                  </Card>
                  <Card padding="md" className="shadow-none border-slate-200" data-id="element-10861">
                    <div className="text-xs text-slate-500 mb-1" data-id="element-10862">
                      Активных подписчиков
                    </div>
                    <div className="text-2xl font-bold text-blue-600" data-id="element-10863">
                      {a.activeSubscribers.toLocaleString('ru-RU')}
                    </div>
                  </Card>
                  <Card padding="md" className="shadow-none border-slate-200" data-id="element-10864">
                    <div className="text-xs text-slate-500 mb-1" data-id="element-10865">
                      Завершили цепочку
                    </div>
                    <div className="text-2xl font-bold text-emerald-600" data-id="element-10866">
                      {a.completed.toLocaleString('ru-RU')}
                    </div>
                  </Card>
                </div>

                <Card padding="md" className="shadow-none border-slate-200" data-id="element-10867">
                  <h3 className="text-sm font-bold text-slate-900 mb-4" data-id="element-10868">
                    Схема цепочки
                  </h3>
                  <div className="space-y-4 relative before:absolute before:inset-0 before:ml-5 before:-translate-x-px md:before:mx-auto md:before:translate-x-0 before:h-full before:w-0.5 before:bg-gradient-to-b before:from-transparent before:via-slate-300 before:to-transparent" data-id="element-10869">
                    <div className="relative flex items-center justify-between md:justify-normal md:odd:flex-row-reverse group is-active" data-id="element-10870">
                      <div className="flex items-center justify-center w-10 h-10 rounded-full border-4 border-white bg-amber-500 text-white shadow shrink-0 md:order-1 md:group-odd:-translate-x-1/2 md:group-even:translate-x-1/2 z-10" data-id="element-10871">
                        <Target className="w-4 h-4" data-id="element-10872" />
                      </div>
                      <div className="w-[calc(100%-4rem)] md:w-[calc(50%-2.5rem)] p-4 rounded-xl border border-slate-200 bg-white shadow-sm" data-id="element-10873">
                        <div className="font-bold text-slate-900 mb-1" data-id="element-10874">
                          Триггер
                        </div>
                        <div className="text-sm text-slate-500" data-id="element-10875">
                          {a.trigger}
                        </div>
                      </div>
                    </div>

                    <div className="relative flex items-center justify-between md:justify-normal md:odd:flex-row-reverse group is-active" data-id="element-10876">
                      <div className="flex items-center justify-center w-10 h-10 rounded-full border-4 border-white bg-indigo-500 text-white shadow shrink-0 md:order-1 md:group-odd:-translate-x-1/2 md:group-even:translate-x-1/2 z-10" data-id="element-10877">
                        <Mail className="w-4 h-4" data-id="element-10878" />
                      </div>
                      <div className="w-[calc(100%-4rem)] md:w-[calc(50%-2.5rem)] p-4 rounded-xl border border-slate-200 bg-white shadow-sm" data-id="element-10879">
                        <div className="flex justify-between items-start mb-1" data-id="element-10880">
                          <div className="font-bold text-slate-900" data-id="element-10881">
                            Email #1
                          </div>
                          <Badge variant="success" size="sm" data-id="element-10882">
                            Отправлено: 12.4k
                          </Badge>
                        </div>
                        <div className="text-sm text-slate-500" data-id="element-10883">
                          Отправляется сразу после триггера
                        </div>
                      </div>
                    </div>

                    {a.steps > 1 && <div className="relative flex items-center justify-between md:justify-normal md:odd:flex-row-reverse group is-active" data-id="element-10884">
                        <div className="flex items-center justify-center w-10 h-10 rounded-full border-4 border-white bg-slate-400 text-white shadow shrink-0 md:order-1 md:group-odd:-translate-x-1/2 md:group-even:translate-x-1/2 z-10" data-id="element-10885">
                          <Clock className="w-4 h-4" data-id="element-10886" />
                        </div>
                        <div className="w-[calc(100%-4rem)] md:w-[calc(50%-2.5rem)] p-4 rounded-xl border border-slate-200 bg-white shadow-sm" data-id="element-10887">
                          <div className="font-bold text-slate-900 mb-1" data-id="element-10888">
                            Задержка
                          </div>
                          <div className="text-sm text-slate-500" data-id="element-10889">
                            Ожидание 2 дня
                          </div>
                        </div>
                      </div>}
                  </div>
                </Card>
              </div>}
          </div>
        </Card>
      </div>;
  };
  // --- AB TEST DETAIL MODAL ---
  const renderAbTestDetailModal = () => {
    if (!activeAbTestDetail) return null;
    const t = activeAbTestDetail;
    return <div className="fixed inset-0 z-50 flex items-center justify-center p-4 sm:p-6 bg-slate-900/50 backdrop-blur-sm" data-id="element-10890">
        <Card className="w-full max-w-4xl max-h-[90vh] flex flex-col shadow-2xl overflow-hidden" data-id="element-10891">
          <div className="flex justify-between items-start p-6 border-b border-slate-200 bg-white shrink-0" data-id="element-10892">
            <div className="flex items-start gap-4" data-id="element-10893">
              <div className="w-12 h-12 rounded-xl bg-rose-50 flex items-center justify-center text-rose-600 shrink-0" data-id="element-10894">
                <SplitSquareHorizontal className="w-6 h-6" data-id="element-10895" />
              </div>
              <div data-id="element-10896">
                <div className="flex items-center gap-3 mb-1" data-id="element-10897">
                  <h2 className="text-xl font-bold text-slate-900" data-id="element-10898">
                    {t.id === 'NEW' ? 'Новый A/B Тест' : t.name}
                  </h2>
                  {t.id !== 'NEW' && <Badge variant={t.status === 'completed' ? 'success' : 'warning'} data-id="element-10899">
                      {t.status}
                    </Badge>}
                </div>
                {t.id !== 'NEW' && <div className="flex items-center gap-4 text-sm text-slate-500" data-id="element-10900">
                    <span className="font-mono text-xs bg-slate-100 px-1.5 py-0.5 rounded" data-id="element-10901">
                      {t.id}
                    </span>
                    <span data-id="element-10902">Кампания: {t.campaignId}</span>
                    <span className="uppercase" data-id="element-10903">Тип: {t.type}</span>
                  </div>}
              </div>
            </div>
            <div className="flex items-center gap-2" data-id="element-10904">
              <Button variant="ghost" size="sm" className="w-8 h-8 p-0" icon={<X className="w-5 h-5" data-id="element-10906" />} onClick={() => setActiveAbTestDetail(null)} data-id="element-10905" />
            </div>
          </div>

          <div className="flex-1 overflow-y-auto p-6 bg-slate-50" data-id="element-10907">
            {t.id === 'NEW' ? <div className="space-y-6 max-w-2xl mx-auto" data-id="element-10908">
                <div data-id="element-10909">
                  <label className="block text-sm font-medium text-slate-700 mb-1" data-id="element-10910">
                    Название теста
                  </label>
                  <input type="text" placeholder="Например: Тест заголовков" className="w-full rounded-lg border border-slate-200 px-4 py-2 text-sm focus:outline-none focus:border-indigo-500" data-id="element-10911" />
                </div>
                <div data-id="element-10912">
                  <label className="block text-sm font-medium text-slate-700 mb-1" data-id="element-10913">
                    Кампания
                  </label>
                  <select className="w-full rounded-lg border border-slate-200 px-4 py-2 text-sm focus:outline-none focus:border-indigo-500" data-id="element-10914">
                    <option data-id="element-10915">Выберите кампанию...</option>
                    {mockCampaigns.map(c => <option key={c.id} value={c.id} data-id="element-10916">
                        {c.name}
                      </option>)}
                  </select>
                </div>
                <div data-id="element-10917">
                  <label className="block text-sm font-medium text-slate-700 mb-1" data-id="element-10918">
                    Что тестируем?
                  </label>
                  <select className="w-full rounded-lg border border-slate-200 px-4 py-2 text-sm focus:outline-none focus:border-indigo-500" data-id="element-10919">
                    <option value="subject" data-id="element-10920">Тема письма (Subject)</option>
                    <option value="content" data-id="element-10921">Контент / Шаблон</option>
                    <option value="sender" data-id="element-10922">Имя отправителя</option>
                    <option value="time" data-id="element-10923">Время отправки</option>
                  </select>
                </div>
                <div className="grid grid-cols-2 gap-4" data-id="element-10924">
                  <div data-id="element-10925">
                    <label className="block text-sm font-medium text-slate-700 mb-1" data-id="element-10926">
                      Вариант A (Контрольный)
                    </label>
                    <input type="text" className="w-full rounded-lg border border-slate-200 px-4 py-2 text-sm focus:outline-none focus:border-indigo-500" data-id="element-10927" />
                  </div>
                  <div data-id="element-10928">
                    <label className="block text-sm font-medium text-slate-700 mb-1" data-id="element-10929">
                      Вариант B (Тестовый)
                    </label>
                    <input type="text" className="w-full rounded-lg border border-slate-200 px-4 py-2 text-sm focus:outline-none focus:border-indigo-500" data-id="element-10930" />
                  </div>
                </div>
                <div className="pt-4 border-t border-slate-200 flex justify-end gap-3" data-id="element-10931">
                  <Button variant="outline" onClick={() => setActiveAbTestDetail(null)} data-id="element-10932">
                    Отмена
                  </Button>
                  <Button variant="primary" onClick={() => {
                success('A/B Тест создан');
                setActiveAbTestDetail(null);
              }} data-id="element-10933">
                    Создать тест
                  </Button>
                </div>
              </div> : <div className="space-y-6" data-id="element-10934">
                {t.winner && <div className="bg-emerald-50 border border-emerald-200 text-emerald-800 p-4 rounded-xl flex items-center gap-3" data-id="element-10935">
                    <CheckCircle2 className="w-6 h-6 text-emerald-600" data-id="element-10936" />
                    <div data-id="element-10937">
                      <div className="font-bold" data-id="element-10938">
                        Тест завершен. Победитель: {t.winner}
                      </div>
                      <div className="text-sm text-emerald-600" data-id="element-10939">
                        Оставшаяся аудитория получит победивший вариант.
                      </div>
                    </div>
                  </div>}

                <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-10940">
                  <Card padding="md" className="shadow-none border-slate-200" data-id="element-10941">
                    <div className="flex justify-between items-center mb-4" data-id="element-10942">
                      <h3 className="text-sm font-bold text-slate-900" data-id="element-10943">
                        Вариант A
                      </h3>
                      <Badge variant="neutral" data-id="element-10944">
                        {t.split.split('/')[0]}% аудитории
                      </Badge>
                    </div>
                    <div className="bg-slate-100 p-3 rounded-lg mb-6" data-id="element-10945">
                      <div className="text-sm text-slate-700" data-id="element-10946">{t.variantA}</div>
                    </div>
                    <div className="space-y-4" data-id="element-10947">
                      <div data-id="element-10948">
                        <div className="flex justify-between text-xs text-slate-500 mb-1" data-id="element-10949">
                          <span data-id="element-10950">Open Rate</span>
                          <span className="font-bold text-slate-900" data-id="element-10951">
                            32.4%
                          </span>
                        </div>
                        <div className="w-full bg-slate-100 rounded-full h-2" data-id="element-10952">
                          <div className="bg-blue-500 h-2 rounded-full" style={{
                        width: '32.4%'
                      }} data-id="element-10953"></div>
                        </div>
                      </div>
                      <div data-id="element-10954">
                        <div className="flex justify-between text-xs text-slate-500 mb-1" data-id="element-10955">
                          <span data-id="element-10956">CTR</span>
                          <span className="font-bold text-slate-900" data-id="element-10957">4.1%</span>
                        </div>
                        <div className="w-full bg-slate-100 rounded-full h-2" data-id="element-10958">
                          <div className="bg-purple-500 h-2 rounded-full" style={{
                        width: '4.1%'
                      }} data-id="element-10959"></div>
                        </div>
                      </div>
                    </div>
                  </Card>

                  <Card padding="md" className="shadow-none border-slate-200 relative overflow-hidden" data-id="element-10960">
                    {t.winner?.includes('Variant B') && <div className="absolute top-0 right-0 bg-emerald-500 text-white text-[10px] font-bold px-3 py-1 rounded-bl-lg" data-id="element-10961">
                        ПОБЕДИТЕЛЬ
                      </div>}
                    <div className="flex justify-between items-center mb-4" data-id="element-10962">
                      <h3 className="text-sm font-bold text-slate-900" data-id="element-10963">
                        Вариант B
                      </h3>
                      <Badge variant="neutral" data-id="element-10964">
                        {t.split.split('/')[1]}% аудитории
                      </Badge>
                    </div>
                    <div className="bg-slate-100 p-3 rounded-lg mb-6" data-id="element-10965">
                      <div className="text-sm text-slate-700" data-id="element-10966">{t.variantB}</div>
                    </div>
                    <div className="space-y-4" data-id="element-10967">
                      <div data-id="element-10968">
                        <div className="flex justify-between text-xs text-slate-500 mb-1" data-id="element-10969">
                          <span data-id="element-10970">Open Rate</span>
                          <span className="font-bold text-emerald-600" data-id="element-10971">
                            38.2%
                          </span>
                        </div>
                        <div className="w-full bg-slate-100 rounded-full h-2" data-id="element-10972">
                          <div className="bg-emerald-500 h-2 rounded-full" style={{
                        width: '38.2%'
                      }} data-id="element-10973"></div>
                        </div>
                      </div>
                      <div data-id="element-10974">
                        <div className="flex justify-between text-xs text-slate-500 mb-1" data-id="element-10975">
                          <span data-id="element-10976">CTR</span>
                          <span className="font-bold text-emerald-600" data-id="element-10977">
                            5.8%
                          </span>
                        </div>
                        <div className="w-full bg-slate-100 rounded-full h-2" data-id="element-10978">
                          <div className="bg-emerald-500 h-2 rounded-full" style={{
                        width: '5.8%'
                      }} data-id="element-10979"></div>
                        </div>
                      </div>
                    </div>
                  </Card>
                </div>
              </div>}
          </div>
        </Card>
      </div>;
  };
  return <div className="space-y-6" data-id="element-10980">
      {/* Top Navigation Tabs */}
      <Tabs activeTab={activeTab} onChange={setActiveTab} tabs={[{
      id: 'campaigns',
      label: 'Кампании'
    }, {
      id: 'templates',
      label: 'Шаблоны'
    }, {
      id: 'audiences',
      label: 'Аудитории'
    }, {
      id: 'automations',
      label: 'Автоматизации'
    }, {
      id: 'abtests',
      label: 'A/B Тесты'
    }]} data-id="element-10981" />

      {/* Main Content Area */}
      <div data-id="element-10982">
        {activeTab === 'campaigns' && <>
            {renderTopMetrics()}
            {renderCampaignsTable()}
          </>}
        {activeTab === 'templates' && renderTemplates()}
        {activeTab === 'audiences' && renderAudiences()}
        {activeTab === 'automations' && renderAutomations()}
        {activeTab === 'abtests' && renderAbTests()}
      </div>

      {/* Modals */}
      {renderCampaignDetailModal()}
      {renderCreateModal()}
      {renderTemplateDetailModal()}
      {renderSegmentDetailModal()}
      {renderAutomationDetailModal()}
      {renderAbTestDetailModal()}
    </div>;
}